// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fjs-editor-container {
  --color-children-selected-border: var(--cds-border-interactive, var(--color-blue-219-100-53));
  --color-children-selected-background: transparent;
  --color-children-hover-border: var(--cds-border-interactive, var(--color-blue-219-100-53-05));
  --color-context-pad-item-background: transparent;
  --color-context-pad-item-fill: var(--cds-icon-secondary, var(--color-grey-225-10-15));
  --color-context-pad-item-hover-fill: var(--color-red-360-100-45);
  --color-resize-handle-background: var(--cds-border-interactive, var(--color-blue-219-100-53));
  --color-resize-handle-border: var(--cds-border-interactive, var(--color-blue-219-100-53));
  --color-dragula-background: var(--cds-highlight, var(--color-blue-205-100-95));
  --color-dragula-border: var(--cds-border-interactive, var(--color-blue-205-100-45));
  --color-dragula-mirror-background: var(--cds-background, var(--color-white));
  --color-dragula-mirror-border: var(--cds-border-strong, var(--cds-border-strong-01, var(--color-grey-225-10-90)));
  --color-dragula-error-background: var(--color-red-360-100-92);
  --color-dragula-error-border: var(--cds-text-error, var(--color-red-360-100-45));
}

.fjs-palette-container {
  --color-palette-text: var(--cds-text-primary, var(--color-grey-225-10-15));
  --color-palette-container-background: var(--cds-background, var(--color-grey-225-10-95));
  --color-palette-container-border: var(--cds-border-strong, var(--cds-border-strong-01, var(--color-grey-225-10-80)));
  --color-palette-header: var(--cds-text-primary, var(--color-text));
  --color-palette-header-background: var(--cds-background, var(--color-grey-225-10-95));
  --color-palette-header-border: var(--cds-border-strong, var(--cds-border-strong-01, var(--color-grey-225-10-85)));
  --color-palette-search: var(--color-palette-text);
  --color-palette-search-icon: var(--cds-icon-secondary, var(--color-grey-225-10-35));
  --color-palette-search-icon-hover: var(--cds-icon-primary, var(--color-grey-225-10-15));
  --color-palette-search-background: var(--cds-field, var(--cds-field-01, var(--color-white)));
  --color-palette-search-border: var(--cds-border-strong, var(--cds-border-strong-01, var(--color-grey-225-10-75)));
  --color-palette-search-focus-background: var(--cds-field, var(--cds-field-01, var(--color-blue-205-100-95)));
  --color-palette-search-focus-border: var(--cds-focus, var(--color-blue-205-100-50));
  --color-palette-search-clear-focus-border: var(--cds-focus, var(--color-grey-225-10-50));
  --color-palette-group-title: var(--color-palette-text);
  --color-palette-field: var(--color-palette-text);
  --color-palette-field-background: var(--cds-layer, var(--cds-layer-01, var(--color-white)));
  --color-palette-field-border: var(--cds-border-subtle, var(--cds-border-subtle-01, var(--color-grey-225-10-93)));
  --color-palette-field-focus: var(--cds-border-interactive, var(--color-blue-205-100-45));
  --color-palette-field-hover-background: var(--cds-background-hover, var(--color-grey-225-10-90));
  --color-palette-field-hover-border: var(
    --cds-border-strong,
    var(--cds-border-strong-01, var(--color-grey-225-10-55))
  );
  --cursor-palette-field: grab;
  --palette-width: 270px;
}

.fjs-properties-container {
  --color-properties-container-background: var(--cds-background, var(--color-white));
  --color-properties-container-border: var(
    --cds-border-strong,
    var(--cds-border-strong-01, var(--color-grey-225-10-80))
  );
  --properties-panel-width: 300px;
}

/**
 * Theming overrides
 */
.fjs-properties-container .bio-properties-panel {
  --text-base-color: var(--cds-text-primary, var(--color-grey-225-10-15));
  --text-error-color: var(--cds-text-color, var(--color-red-360-100-45));
  --link-color: var(--cds-text-primary, var(--color-blue-205-100-50));
  --description-color: var(--cds-text-secondary, var(--color-grey-225-10-35));
  --description-code-background-color: var(--cds-layer, var(--cds-layer-01, var(--color-grey-225-10-97)));
  --description-code-border-color: var(--cds-border-strong, var(--cds-border-strong-01, var(--color-grey-225-10-85)));
  --description-list-item-color: var(--cds-text-secondary, var(--color-grey-225-10-35));
  --placeholder-color: var(--cds-text-placeholder, var(--color-grey-225-10-35));
  --placeholder-background-color: var(--cds-layer, var(--cds-layer-01, var(--color-grey-225-10-95)));
  --header-background-color: var(--cds-layer, var(--cds-layer-01, var(--color-grey-225-10-95)));
  --header-icon-fill-color: var(--cds-icon-primary, var(--color-grey-225-10-15));
  --header-bottom-border-color: var(--color-grey-225-10-75);
  --group-background-color: var(--cds-background, var(--color-white));
  --group-bottom-border-color: var(--cds-border-strong, var(--cds-border-strong-01, var(--color-grey-225-10-75)));
  --sticky-group-background-color: var(--cds-layer, var(--cds-layer-01, var(--color-grey-225-10-95)));
  --sticky-group-bottom-border-color: var(
    --cds-border-strong,
    var(--cds-border-strong-01, var(--color-grey-225-10-75))
  );
  --add-entry-fill-color: var(--cds-icon-secondary, var(--color-grey-225-10-35));
  --add-entry-hover-fill-color: var(--cds-icon-inverse, var(--color-white));
  --add-entry-hover-background-color: var(--cds-interactive, var(--color-blue-205-100-50));
  --add-entry-label-color: var(--cds-text-inverse, var(--color-white));
  --remove-entry-fill-color: var(--color-red-360-100-45);
  --remove-entry-hover-background-color: var(--color-red-360-100-92);
  --arrow-fill-color: var(--cds-icon-secondary, var(--color-grey-225-10-35));
  --arrow-hover-background-color: var(--cds-layer, var(--cds-layer-01, var(--color-grey-225-10-95)));
  --dot-color: var(--cds-text-secondary, var(--color-grey-225-10-35));
  --list-badge-color: var(--cds-text-inverse, var(--color-white));
  --list-badge-background-color: var(--cds-background-inverse, var(--color-grey-225-10-35));
  --input-background-color: var(--cds-field, var(--cds-field-01, var(--color-grey-225-10-97)));
  --input-border-color: var(--cds-border-strong, var(--cds-border-strong-01, var(--color-grey-225-10-75)));
  --input-focus-background-color: var(--cds-field, var(--cds-field-01, var(--color-blue-205-100-95)));
  --input-focus-border-color: var(--cds-focus, var(--color-blue-205-100-50));
  --input-error-background-color: var(--cds-field, var(--cds-field-01, var(--color-red-360-100-97)));
  --input-error-border-color: var(--cds-text-error, var(--color-red-360-100-45));
  --input-error-focus-border-color: var(--cds-text-error, var(--color-red-360-100-45));
  --input-disabled-color: var(--cds-text-disabled, var(--color-grey-225-10-55));
  --input-disabled-background-color: var(--cds-field, var(--cds-field-01, var(--color-grey-225-10-97)));
  --input-disabled-border-color: var(--cds-border-disabled, var(--color-grey-225-10-90));
  --toggle-switch-on-background-color: var(--cds-interactive, var(--color-blue-205-100-50));
  --toggle-switch-off-background-color: var(--cds-toggle-off, var(--color-grey-225-10-75));
  --toggle-switch-switcher-background-color: var(--cds-background, var(--color-white));
  --side-line-background-color: var(--cds-text-secondary, var(--color-grey-225-10-35));
  --side-line-extension-background-color: var(--cds-text-secondary, (--color-grey-225-10-35));
  --list-entry-dot-background-color: var(--cds-background-inverse, var(--color-grey-225-10-35));
  --list-entry-header-button-fill-color: var(--cds-background-inverse, var(--color-grey-225-10-35));
  --list-entry-add-entry-empty-background-color: var(--cds-interactive, var(--color-blue-205-100-50));
  --list-entry-add-entry-empty-hover-background-color: var(--cds-interactive, var(--color-blue-205-100-45));
  --list-entry-add-entry-label-color: var(--cds-text-inverse, var(--color-white));
  --list-entry-add-entry-background-color: var(--cds-interactive, var(--color-blue-205-100-50));
  --list-entry-add-entry-fill-color: var(--cds-icon-inverse, var(--color-white));
  --feel-background-color: transparent;
  --feel-active-color: var(--cds-interactive, var(--color-blue-205-100-45));
  --feel-inactive-color: var(--cds-icon-secondary, var(--color-grey-225-10-35));
  --feel-hover-color: var(--cds-icon-primary, var(--color-grey-225-10-15));
  --feel-hover-background-color: var(--cds-layer-02, var(--color-grey-225-10-97));
  --feel-active-background-color: transparent;
  --feel-required-color: var(--cds-icon-disabled, var(--color-grey-225-10-55));
  --feel-indicator-background-color: var(--cds-background-hover, var(--color-grey-225-10-90));
}

.fjs-properties-container .bio-properties-panel-input {
  color: var(--color-text);
}

.fjs-editor-container {
  height: 100%;
  width: 100%;
  display: flex;
}

.fjs-editor-container .fjs-form-editor {
  display: flex;
  flex: 1;
  flex-direction: row;
}

.fjs-editor-container .fjs-form-container {
  overflow-y: auto;
  position: relative;
}

.fjs-editor-container .fjs-render-injector-container {
  width: 0;
  height: 0;
  display: none;
  overflow: hidden;
}

.fjs-editor-container .fjs-form-container,
.fjs-editor-container .fjs-form {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.fjs-editor-container .fjs-form > .fjs-element {
  flex-grow: 1;
}

.fjs-editor-container .fjs-children .fjs-children {
  margin: 3px 0;
}

.fjs-editor-container .fjs-children .fjs-element {
  position: relative;
  border: solid 2px transparent;
  outline: none;
}

.fjs-editor-container .fjs-form > .fjs-element {
  border: none;
  outline: none;
}

.fjs-editor-container .fjs-form-field:not(.fjs-powered-by) {
  margin: 1px 6px;
}

.fjs-editor-container .fjs-children .fjs-element.fjs-outlined {
  border-color: var(--color-borders-group);
}

.fjs-editor-container .fjs-children .fjs-element.fjs-dashed-outlined {
  border-color: var(--color-borders-group);
  border-style: dashed;
}

.fjs-editor-container .fjs-children .fjs-element.fjs-editor-selected {
  border-color: var(--color-children-selected-border) !important;
  background-color: var(--color-children-selected-background);
  border-style: solid;
}

.fjs-editor-container .fjs-children .fjs-element:hover.fjs-editor-hovered,
.fjs-editor-container .fjs-children .fjs-element:focus {
  border-color: var(--color-children-hover-border);
  border-style: solid;
}

.fjs-editor-container .fjs-layout-column:first-child > .fjs-element[data-field-type=group],
.fjs-editor-container .fjs-layout-column:first-child > .fjs-element[data-field-type=dynamiclist] {
  margin-left: -6px;
}

.fjs-editor-container .fjs-layout-column:last-child > .fjs-element[data-field-type=group],
.fjs-editor-container .fjs-layout-column:last-child > .fjs-element[data-field-type=dynamiclist] {
  margin-right: -6px;
}

.fjs-editor-container .fjs-form-field-grouplike,
.fjs-editor-container .fjs-form-field-grouplike .fjs-form-field-grouplike .fjs-form-field-grouplike {
  margin: 1px 6px;
  padding: 0px;
}

.fjs-editor-container .fjs-form-field-grouplike.fjs-outlined {
  outline: none;
}

.fjs-editor-container .fjs-form-field-grouplike .cds--grid {
  padding: 0 2rem;
}

.fjs-editor-container .fjs-form-field-grouplike > label {
  margin-top: 6px;
}

.fjs-editor-container .fjs-input:disabled,
.fjs-editor-container .fjs-textarea:disabled,
.fjs-editor-container .fjs-taglist-input:disabled,
.fjs-editor-container .fjs-button:disabled,
.fjs-editor-container .fjs-select:disabled {
  pointer-events: none;
}

.fjs-editor-container .fjs-readonly {
  pointer-events: none;
}

.fjs-editor-container .fjs-drag-container,
.fjs-editor-container .fjs-drop-container-vertical {
  user-select: none;
}

.fjs-editor-container .fjs-empty-component {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  width: calc(100% - 4rem);
  position: absolute;
  container-type: size;
}

.fjs-editor-container .fjs-empty-component .fjs-empty-component-text {
  color: var(--cds-text-disabled, var(--color-grey-225-10-55));
}

@container (width < 100px) {
  .fjs-empty-component-text {
    display: none;
  }
}
.fjs-editor-container .fjs-empty-editor {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.fjs-cursor-grabbing .fjs-editor-container .fjs-empty-editor {
  display: none;
}

.fjs-editor-container .fjs-empty-editor .fjs-empty-editor-card {
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.fjs-editor-container .fjs-drop-container-horizontal {
  width: 100%;
}

.fjs-editor-container .fjs-layout-row {
  padding: 4px 0px;
}

.fjs-editor-container .fjs-drag-row-move {
  display: flex;
  width: 100%;
  padding: 3px 0px;
  position: relative;
}

.fjs-editor-container .fjs-row-dragger {
  z-index: 2;
  position: absolute;
  top: 25%;
  height: 50%;
  left: -33px;
  width: 23px;
  padding-right: 7px;
  cursor: grab;
  display: flex;
  justify-content: center;
  align-items: center;
}

.fjs-editor-container .fjs-row-dragger svg {
  visibility: hidden;
}

.fjs-editor-container .fjs-row-dragger:hover svg,
.fjs-editor-container .fjs-drag-row-move:hover > .fjs-row-dragger svg {
  visibility: visible;
}

.fjs-editor-container .fjs-drag-move {
  padding: 0 3px;
}

.fjs-editor-container .fjs-field-resize-handle {
  resize: horizontal;
  position: absolute;
  visibility: hidden;
  width: 6px;
  top: 0;
  bottom: 0;
  margin: auto;
  height: 50px;
  max-height: calc(100% - 2px);
  border: 1px solid var(--color-resize-handle-border);
  border-radius: 50px;
  background: var(--color-white);
  z-index: 3;
}

.fjs-editor-container .fjs-field-resize-handle-right {
  right: -4px;
  cursor: ew-resize;
}

.fjs-editor-container .fjs-field-resize-handle-left {
  left: -4px;
  cursor: ew-resize;
}

.fjs-editor-container .fjs-element-resizing-right .fjs-field-resize-handle-right,
.fjs-editor-container .fjs-element-resizing-left .fjs-field-resize-handle-left,
.fjs-editor-container .fjs-field-resize-handle:hover {
  background: var(--color-resize-handle-background);
}

.fjs-editor-container .fjs-element-resizing-right .fjs-context-pad,
.fjs-editor-container .fjs-element-resizing-left .fjs-context-pad {
  display: none;
}

.fjs-editor-container .fjs-children .fjs-editor-selected > .fjs-field-resize-handle {
  visibility: visible;
}

.fjs-resize-drag-preview {
  width: 1px;
  height: 1px;
  position: absolute;
  top: 0;
}

.fjs-editor-container .fjs-repeat-render-footer {
  font-size: var(--font-size-label);
  background: var(--cds-field, var(--color-background-disabled));
  color: var(--color-text-light);
  padding: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px 5px 3px 5px;
}

.fjs-editor-container .fjs-repeat-render-footer svg {
  margin-right: 4px;
}

/* do not show resize handles on small screens */
@media (max-width: 66rem) {
  .fjs-editor-container .fjs-children .fjs-editor-selected .fjs-field-resize-handle {
    display: none !important;
  }
}
/**
 * Cursor styles
 */
.fjs-cursor-grab {
  cursor: -webkit-grab;
  cursor: -moz-grab;
  cursor: grab;
}

.fjs-cursor-grabbing {
  cursor: -webkit-grabbing;
  cursor: -moz-grabbing;
  cursor: grabbing;
}

.fjs-cursor-crosshair {
  cursor: crosshair;
}

.fjs-cursor-move {
  cursor: move;
}

.fjs-cursor-not-allowed {
  cursor: not-allowed;
}

/**
 * Context Pad
 */
.fjs-editor-container .fjs-context-pad {
  z-index: 2;
  position: absolute;
  top: 0;
  right: 5px;
}

.fjs-editor-container .fjs-context-pad-item {
  border: none;
  background-color: var(--color-context-pad-item-background);
  padding: 0;
  width: 24px;
  height: 24px;
  color: var(--color-context-pad-item-fill);
  display: flex;
  justify-content: center;
  align-items: center;
}

.fjs-editor-container .fjs-context-pad-item:hover {
  color: var(--color-context-pad-item-hover-fill);
}

.fjs-editor-container .fjs-context-pad-item:focus-visible {
  outline: 2px solid var(--color-children-selected-border);
  border-radius: 2px;
}

/**
 * Palette
 */
.fjs-editor-container .fjs-palette-container {
  height: 100%;
}

.fjs-palette-container {
  width: var(--palette-width);
  background-color: var(--color-palette-container-background);
  border-right: solid 1px var(--color-palette-container-border);
  font-family: var(--font-family);
}

.fjs-palette-container .fjs-palette {
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.fjs-palette-container .fjs-palette-header {
  font-size: 14px;
  font-weight: bold;
  color: var(--color-palette-header);
  padding: 10px 15px;
  border-bottom: solid 1px var(--color-palette-header-border);
  background: var(--color-palette-header-background);
  user-select: none;
}

.fjs-palette-container .fjs-palette-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.fjs-palette-container .fjs-palette-footer .fjs-palette-footer-fill {
  padding: 10px;
  width: 100%;
}

.fjs-palette-container .fjs-palette-search-container {
  display: flex;
  flex-direction: row;
  padding: 4px;
  margin: 12px;
  color: var(--color-palette-search);
  border: 1px solid var(--color-palette-search-border);
  background-color: var(--color-palette-search-background);
  border-radius: 2px;
  font-size: 14px;
}

.fjs-palette-container .fjs-palette-search-container:focus-within {
  outline: none;
  background-color: var(--color-palette-search-focus-background);
  border: 1px solid var(--color-palette-search-focus-border);
}

.fjs-palette-container .fjs-palette-search-icon {
  margin-right: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-palette-search-icon);
}

.fjs-palette-container .fjs-palette-search {
  background-color: inherit;
  font-family: inherit;
  margin: 0;
  border: none;
  padding: 0;
  color: var(--color-palette-text);
}

.fjs-palette-container .fjs-palette-search:focus {
  outline: none;
}

.fjs-palette-container .fjs-palette-search-clear {
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  margin-left: auto;
  padding: 0;
  background: transparent;
  color: var(--color-palette-search-icon);
}

.fjs-palette-container .fjs-palette-search-clear svg {
  margin: 0;
}

.fjs-palette-container .fjs-palette-search-clear:hover {
  color: var(--color-palette-search-icon-hover);
}

.fjs-palette-container .fjs-palette-entries {
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  gap: 20px;
  padding-bottom: 20px;
}

.fjs-palette-container .fjs-palette-group {
  display: flex;
  flex-direction: column;
  width: 236px;
  margin: auto;
}

.fjs-palette-container .fjs-palette-group-title {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 4px;
  color: var(--color-palette-group-title);
  user-select: none;
}

.fjs-palette-container .fjs-palette-fields {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.fjs-palette-field {
  height: 72px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 11px;
  align-items: center;
  border: none;
  font-family: inherit;
  user-select: none;
  color: var(--color-palette-field);
  background-color: var(--color-palette-field-background);
  outline: solid 1px var(--color-palette-field-border);
  outline-offset: 0px;
  transition: all ease-in-out 0.05s;
}

.fjs-palette-container .fjs-palette-field {
  width: 72px;
}

.fjs-palette-container .fjs-palette-field:focus {
  outline: solid 1px var(--color-palette-field-focus);
}

.fjs-palette-field .fjs-palette-field-icon,
.fjs-palette-field .fjs-field-icon-image {
  margin: 0 auto;
}

.fjs-palette-field .fjs-palette-field-text {
  text-align: center;
  width: inherit;
}

.fjs-palette-container .fjs-palette-field:hover {
  outline: solid 1px var(--color-palette-field-hover-border);
  cursor: var(--cursor-palette-field);
}

.fjs-palette-container .fjs-palette-no-entries {
  padding: 5px 15px;
  font-size: 14px;
  color: var(--color-palette-text);
}

/**
 * JSON Editors
 */
.fjs-json-editor .cm-editor {
  font-size: var(--font-size-label);
  line-height: var(--line-height-label);
  letter-spacing: var(--letter-spacing-label);
}

.fjs-json-editor .cm-placeholder {
  color: var(--cds-text-placeholder, var(--color-grey-225-10-35));
}

.fjs-json-editor .cm-placeholder > :first-child {
  margin-top: 0;
}

.fjs-json-editor.fjs-cm-no-lint .cm-lint-marker,
.fjs-json-editor.fjs-cm-no-lint .cm-lintPoint-error {
  display: none;
}

.fjs-json-editor.fjs-cm-no-lint .cm-activeLine,
.fjs-json-editor.fjs-cm-no-lint .cm-activeLineGutter {
  background: none;
}

/**
 * Properties Panel
 */
.fjs-editor-container .fjs-properties-container {
  height: 100%;
}

.fjs-properties-container {
  background-color: var(--color-properties-container-background);
  width: var(--properties-panel-width);
  border-left: solid 1px var(--color-properties-container-border);
  color: var(--color-text);
}

.fjs-properties-container .fjs-properties-panel {
  height: 100%;
}

.fjs-properties-container .fjs-properties-panel * {
  box-sizing: border-box;
}

.fjs-properties-container .fjs-properties-panel .bio-properties-panel-header-icon svg {
  transform: scale(1.3);
}

.fjs-properties-container .fjs-properties-panel .fjs-properties-panel-detached-description {
  margin: 0px 12px 6px;
}

.fjs-properties-container .fjs-properties-panel .cm-editor {
  max-height: 400px;
}

/**
 * Editor Form Fields
 */
.fjs-editor-container .fjs-form-field-placeholder {
  color: var(--color-text-light);
  font-style: italic;
}

.fjs-editor-container .fjs-form-field-placeholder svg {
  width: 32px;
  height: 32px;
  vertical-align: middle;
  margin-top: -2px;
  margin-right: 2px;
}

.fjs-editor-container .fjs-form-field-spacer {
  min-height: 30px;
  background: repeating-linear-gradient(45deg, #ffffff, #ffffff 10px, #f5f5f5 10px, #f5f5f5 20px);
}

.fjs-editor-container .fjs-form-field-html,
.fjs-editor-container .fjs-form-field-text {
  min-height: 30px;
}

.fjs-editor-container .fjs-form-field-separator hr {
  margin: 10px 2px;
}

/**
 * Custom Dragula Styles
 */
.gu-transit {
  background: var(--color-dragula-background) !important;
  border: dashed 2px var(--color-dragula-border) !important;
  border-radius: 3px !important;
  filter: none !important;
  height: 70px !important;
  opacity: 1 !important;
  /* mitigate for additional border in row */
  flex-grow: 0.98 !important;
  margin: 0 !important;
}

/* row drop preview */
.fjs-children > .gu-transit {
  height: 28px !important;
  width: 100% !important;
  flex: unset !important;
}

/* error drop preview */
.fjs-error-drop > .gu-transit {
  height: 100% !important;
  background: var(--color-dragula-error-background) !important;
  border: none !important;
  width: 6px !important;
  flex: none !important;
  padding: 0 !important;
  border-radius: 5px !important;
}

.fjs-error-drop.cds--row {
  flex-wrap: nowrap !important;
}

.gu-transit * {
  display: none !important;
}

.gu-mirror {
  background-color: var(--color-dragula-mirror-background) !important;
  border: solid 1px var(--color-dragula-mirror-border) !important;
  border-radius: 5px !important;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15) !important;
  display: flex !important;
  filter: none !important;
  flex-direction: row !important;
  justify-content: center !important;
  align-items: center !important;
  opacity: 0.5 !important;
  padding: 0 !important;
  pointer-events: none !important;
  height: 54px !important;
}

.fjs-field-preview {
  margin: 5px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 11px;
  user-select: none;
  color: var(--color-text);
  background: var(--color-white);
}

.fjs-field-preview .fjs-field-preview-icon {
  margin: 0 auto;
}

.fjs-field-preview .fjs-field-preview-text {
  text-align: center;
}

.gu-mirror.fjs-field-preview-container {
  transform: rotate(-15deg);
  font-family: var(--font-family);
  width: 68px !important;
  height: 68px !important;
}

.gu-mirror.fjs-drag-row-move {
  padding: 4px 12px !important;
  height: fit-content !important;
  opacity: 0.8 !important;
  max-height: 120px !important;
  overflow: hidden !important;
  align-items: start !important;
}

.gu-mirror.fjs-drag-row-move .cds--row {
  flex-wrap: nowrap !important;
}

.gu-mirror {
  position: fixed !important;
  margin: 0 !important;
  z-index: 9999 !important;
  opacity: 0.8;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=80)";
  filter: alpha(opacity=80);
}

.gu-hide {
  display: none !important;
}

.gu-unselectable {
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
}

.gu-transit {
  opacity: 0.2;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=20)";
  filter: alpha(opacity=20);
}

/**
 * Theming
 */
.bio-properties-panel,
.djs-parent {
  --color-grey-225-10-15: hsl(225, 10%, 15%);
  --color-grey-225-10-35: hsl(225, 10%, 35%);
  --color-grey-225-10-55: hsl(225, 10%, 55%);
  --color-grey-225-10-75: hsl(225, 10%, 75%);
  --color-grey-225-10-80: hsl(225, 10%, 80%);
  --color-grey-225-10-85: hsl(225, 10%, 85%);
  --color-grey-225-10-90: hsl(225, 10%, 90%);
  --color-grey-225-10-95: hsl(225, 10%, 95%);
  --color-grey-225-10-97: hsl(225, 10%, 97%);
  --color-grey-0-0-22: hsl(0, 0%, 22%);
  --color-blue-205-100-35: hsl(205, 100%, 35%);
  --color-blue-205-100-40: hsl(205, 100%, 40%);
  --color-green-150-86-44: hsl(150, 86%, 44%);
  --color-blue-205-100-45: hsl(205, 100%, 45%);
  --color-blue-205-100-50: hsl(205, 100%, 50%);
  --color-blue-219-99-53: hsl(219, 99%, 53%);
  --color-blue-218-100-74: hsl(218, 100%, 74%);
  --color-blue-205-100-85: hsl(205, 100%, 85%);
  --color-blue-205-100-95: hsl(205, 100%, 95%);
  --color-red-360-100-40: hsl(360, 100%, 40%);
  --color-red-360-100-45: hsl(360, 100%, 45%);
  --color-red-360-100-92: hsl(360, 100%, 92%);
  --color-red-360-100-97: hsl(360, 100%, 97%);
  --color-white: white;
  --color-black: black;
  --color-transparent: transparent;
}

.bio-properties-panel {
  --text-base-color: var(--color-grey-225-10-15);
  --text-error-color: var(--color-red-360-100-45);
  --link-color: var(--color-blue-205-100-50);
  --description-color: var(--color-grey-225-10-35);
  --description-code-background-color: var(--color-grey-225-10-97);
  --description-code-border-color: var(--color-grey-225-10-85);
  --description-list-item-color: var(--color-grey-225-10-35);
  --placeholder-color: var(--color-grey-225-10-35);
  --placeholder-background-color: var(--color-grey-225-10-95);
  --header-background-color: var(--color-grey-225-10-95);
  --header-icon-fill-color: var(--color-grey-225-10-15);
  --header-bottom-border-color: var(--color-grey-225-10-75);
  --group-background-color: var(--color-white);
  --group-bottom-border-color: var(--color-grey-225-10-75);
  --sticky-group-background-color: var(--color-grey-225-10-95);
  --sticky-group-bottom-border-color: var(--color-grey-225-10-75);
  --add-entry-fill-color: var(--color-grey-225-10-35);
  --add-entry-hover-fill-color: var(--color-white);
  --add-entry-hover-background-color: var(--color-blue-205-100-50);
  --add-entry-label-color: var(--color-white);
  --remove-entry-fill-color: var(--color-red-360-100-45);
  --remove-entry-hover-background-color: var(--color-red-360-100-92);
  --arrow-fill-color: var(--color-grey-225-10-35);
  --arrow-hover-background-color: var(--color-grey-225-10-95);
  --dot-color: var(--color-grey-225-10-35);
  --dot-color-error: var(--color-red-360-100-45);
  --list-badge-color: var(--color-white);
  --list-badge-background-color: var(--color-grey-225-10-35);
  --input-background-color: var(--color-grey-225-10-97);
  --input-border-color: var(--color-grey-225-10-75);
  --input-focus-background-color: var(--color-blue-205-100-95);
  --input-focus-border-color: var(--color-blue-205-100-50);
  --focus-outline-color: var(--color-blue-205-100-40);
  --input-error-background-color: var(--color-red-360-100-97);
  --input-error-border-color: var(--color-red-360-100-45);
  --input-error-focus-border-color: var(--color-red-360-100-45);
  --input-disabled-color: var(--color-grey-225-10-55);
  --input-disabled-background-color: var(--color-grey-225-10-97);
  --input-disabled-border-color: var(--color-grey-225-10-90);
  --toggle-switch-on-background-color: var(--color-blue-205-100-50);
  --toggle-switch-off-background-color: var(--color-grey-225-10-75);
  --toggle-switch-switcher-background-color: var(--color-white);
  --side-line-background-color: var(--color-grey-225-10-35);
  --side-line-extension-background-color: var(--color-grey-225-10-35);
  --list-entry-dot-background-color: var(--color-grey-225-10-35);
  --list-entry-header-button-fill-color: var(--color-grey-225-10-35);
  --list-entry-add-entry-empty-background-color: var(--color-blue-205-100-50);
  --list-entry-add-entry-empty-hover-background-color: var(--color-blue-205-100-45);
  --list-entry-add-entry-label-color: var(--color-white);
  --list-entry-add-entry-background-color: var(--color-blue-205-100-50);
  --list-entry-add-entry-fill-color: var(--color-white);
  --dropdown-item-background-color: var(--color-white);
  --dropdown-item-hover-background-color: var(--color-grey-225-10-95);
  --dropdown-separator-background-color: var(--color-grey-225-10-75);
  --feel-background-color: transparent;
  --feel-active-color: var(--color-blue-205-100-45);
  --feel-inactive-color: var(--color-grey-225-10-35);
  --feel-hover-color: var(--color-grey-225-10-15);
  --feel-hover-background-color: var(--color-grey-225-10-97);
  --feel-active-background-color: transparent;
  --feel-required-color: var(--color-grey-225-10-55);
  --feel-open-popup-color: hsla(0, 0%, 32%, 1);
  --feel-open-popup-background-color: var(--color-white);
  --feel-open-popup-hover-color: hsla(219, 99%, 53%, 1);
  --feel-indicator-background-color: var(--color-grey-225-10-90);
  --feelers-select-color: var(--color-blue-205-100-85);
  --text-size-base: 14px;
  --text-size-small: 13px;
  --text-size-smallest: 12px;
  --text-line-height: 21px;
  --line-height-condensed: 17px;
  --font-family: sans-serif;
  --font-family-monospace: monospace;
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.bio-properties-panel {
  color: var(--text-base-color);
}

.bio-properties-panel * {
  font-size: var(--text-size-base);
  line-height: var(--text-line-height);
  font-weight: 400;
  box-sizing: border-box;
}

.bio-properties-panel {
  font-family: var(--font-family);
}

/**
 * Placeholder (empty, multi select, ...)
 */
.bio-properties-panel-placeholder {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: var(--placeholder-background-color);
}

.bio-properties-panel-placeholder-text {
  color: var(--placeholder-color);
  font-size: var(--text-size-base);
  text-align: center;
  margin: 12px 48px;
}

/**
 * Header
 */
.bio-properties-panel-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: var(--text-size-base);
  padding: 16px 10px;
  background-color: var(--header-background-color);
  border-bottom: 1px solid var(--header-bottom-border-color);
  width: 100%;
  z-index: 10;
  max-height: 64px;
  overflow: hidden;
}

.bio-properties-panel-header-icon {
  fill: var(--header-icon-fill-color);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
}

.bio-properties-panel-header-labels {
  overflow: hidden;
  margin-left: 12px;
  user-select: none;
}

.bio-properties-panel-header-type {
  font-size: var(--text-size-smallest);
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-transform: uppercase;
}

.bio-properties-panel-header-label {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-top: -6px;
}

.bio-properties-panel-header-actions {
  margin-left: auto;
  margin-top: auto;
}

/**
 * Scroll container
 */
.bio-properties-panel-scroll-container {
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
}

/**
 * Groups
 */
.bio-properties-panel-group {
  background-color: var(--group-background-color);
  border-bottom: 1px solid var(--group-bottom-border-color);
  position: relative;
}

.bio-properties-panel-group-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: var(--text-size-base);
  height: 32px;
  user-select: none;
  justify-content: space-between;
  margin-bottom: -1px; /* avoid double borders */
  position: relative; /* browsers not supporting sticky */
  position: -webkit-sticky; /* for safari */
  position: sticky;
  top: 0;
  z-index: 10;
}

.bio-properties-panel-group-header .bio-properties-panel-group-header-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 1px 12px 0;
}

.bio-properties-panel-group-header.open .bio-properties-panel-group-header-title {
  font-weight: 500;
}

.bio-properties-panel-group-header.sticky {
  background-color: var(--sticky-group-background-color);
  border-bottom: 1px solid var(--sticky-group-bottom-border-color);
}

.bio-properties-panel-group-header-buttons {
  display: flex;
}

.bio-properties-panel-group-header-buttons .bio-properties-panel-group-header-button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  height: 22px;
  line-height: 22px;
  min-width: 22px;
  margin: 5px;
  padding: 0 3px;
  border: none;
  background: none;
}

.bio-properties-panel-group-header-button:focus {
  outline-offset: 2px;
  outline-color: var(--focus-outline-color);
}

.bio-properties-panel-group-header-buttons .bio-properties-panel-group-header-buttons:last-child {
  margin-right: 0;
}

.bio-properties-panel-add-entry {
  fill: var(--add-entry-fill-color);
  border-radius: 11px;
}

.bio-properties-panel-group-header.empty .bio-properties-panel-add-entry {
  margin-right: 69px;
}

.bio-properties-panel-group-header.empty .bio-properties-panel-add-entry:hover {
  margin-right: 19px;
}

.bio-properties-panel-group-header.empty .bio-properties-panel-add-entry-label {
  display: none;
  color: var(--add-entry-label-color);
  padding: 0 6px 0 2px;
}

.bio-properties-panel-group-header-button.bio-properties-panel-add-entry:hover {
  background-color: var(--add-entry-hover-background-color);
  fill: var(--add-entry-hover-fill-color);
}

.bio-properties-panel-group-header-button.bio-properties-panel-add-entry:hover .bio-properties-panel-add-entry-label {
  display: block;
}

.bio-properties-panel-group-entries {
  display: none;
}

.bio-properties-panel-group-entries.open {
  display: block;
}

.bio-properties-panel-arrow {
  display: flex;
  justify-content: center;
  text-align: center;
  fill: var(--arrow-fill-color);
  min-width: 22px;
  border-radius: 11px;
  border: none;
  background: none;
}

.bio-properties-panel-arrow:hover {
  background-color: var(--arrow-hover-background-color);
}

.bio-properties-panel-arrow-down {
  transform: rotate(90deg);
}

.bio-properties-panel-dot {
  align-self: center;
  height: 8px;
  min-width: 8px;
  border-radius: 50%;
  margin: 12px;
  background-color: var(--dot-color);
}

.bio-properties-panel-dot--error {
  --dot-color: var(--dot-color-error);
}

/**
 * Lists
 */
.bio-properties-panel-list {
  display: none;
}

.bio-properties-panel-list.open {
  display: block;
  margin-bottom: 6px;
  padding-bottom: 2px;
}

.bio-properties-panel-list-badge {
  height: 22px;
  min-width: 22px;
  color: var(--list-badge-color);
  border-radius: 11px;
  font-size: var(--text-size-small);
  line-height: 22px;
  text-align: center;
  user-select: none;
  padding: 0 5px;
  margin: 5px;
  background-color: var(--list-badge-background-color);
}

.bio-properties-panel-list-badge--error {
  --list-badge-background-color: var(--dot-color-error);
}

/**
 * Basic entries
 */
.bio-properties-panel-entry {
  margin: 2px 32px 6px 12px;
}

.bio-properties-panel-entry:last-child {
  padding-bottom: 10px;
}

.bio-properties-panel-label {
  display: block;
  font-size: var(--text-size-small);
  margin: 2px 0 1px;
}

.bio-properties-panel-description,
.bio-properties-panel-description p,
.bio-properties-panel-description span,
.bio-properties-panel-description div {
  color: var(--description-color);
  display: block;
  margin: 2px 0 4px;
  line-height: var(--line-height-condensed);
  font-weight: 400;
  font-size: var(--text-size-small);
}

.bio-properties-panel-description code {
  color: var(--description-color);
  font-family: var(--font-family);
  font-size: var(--text-size-small);
  line-height: var(--line-height-condensed);
  padding: 0 2px;
  background-color: var(--description-code-background-color);
  border: 1px solid var(--description-code-border-color);
  border-radius: 3px;
}

.bio-properties-panel-description pre code {
  width: 100%;
  display: block;
  overflow-x: auto;
  padding: 4px 6px;
  font-family: var(--font-family-monospace);
}

.bio-properties-panel-description ul {
  padding: 0;
  margin: 0 0 0 12px;
  list-style-type: disc;
}

.bio-properties-panel-description li {
  color: var(--description-list-item-color);
  margin: 0 0 0 12px;
}

.bio-properties-panel-description a {
  color: var(--link-color);
  font-size: var(--text-size-small);
  text-decoration: underline;
}

.bio-properties-panel-feelers-editor.bio-properties-panel-input {
  padding: 0;
}

.bio-properties-panel-feelers-input .cm-editor {
  min-height: 32px;
  max-height: 215px;
  background-color: transparent;
}

.bio-properties-panel-feelers-editor .cm-editor.cm-focused,
.bio-properties-panel-feelers-input .cm-editor.cm-focused {
  outline: none;
}

.bio-properties-panel-input {
  padding: 3px 6px 2px;
  border: 1px solid var(--input-border-color);
  border-radius: 2px;
  background-color: var(--input-background-color);
  font-size: var(--text-size-base);
  font-family: inherit;
}

.bio-properties-panel-input[type=number],
select.bio-properties-panel-input,
textarea.bio-properties-panel-input,
.bio-properties-panel-input[type=text] {
  display: block;
  width: 100%;
}

textarea.bio-properties-panel-input {
  min-height: 28px;
}

.bio-properties-panel-input:focus,
.bio-properties-panel-input:focus-within {
  outline: none;
  background-color: var(--input-focus-background-color);
  border: 1px solid var(--input-focus-border-color);
}

.bio-properties-panel-textfield:focus-within,
.bio-properties-panel-feel-entry:focus-within {
  --input-background-color: var(--input-focus-background-color);
  --input-border-color: var(--input-focus-border-color);
}

.bio-properties-panel-input:disabled {
  border-color: var(--input-disabled-border-color);
  background-color: var(--input-disabled-background-color);
  color: var(--input-disabled-color);
}

select.bio-properties-panel-input {
  padding: 4px 6px;
}

.bio-properties-panel-input-monospace {
  font-family: var(--font-family-monospace);
}

.bio-properties-panel-input[type=checkbox], .bio-properties-panel-input[type=radio] {
  margin: 0;
  vertical-align: middle;
}

.bio-properties-panel-input[type=checkbox]:focus {
  outline: auto;
  outline-color: var(--focus-outline-color);
  outline-offset: 2px;
}

.bio-properties-panel-checkbox > .bio-properties-panel-label {
  display: inline-block;
  font-size: var(--text-size-base);
  margin-left: 6px;
  margin-top: auto;
  vertical-align: middle;
}

.bio-properties-panel-checkbox-entry + .bio-properties-panel-checkbox-entry {
  margin-top: -8px;
}

.bio-properties-panel-checkbox-entry > .bio-properties-panel-description {
  margin-left: 18px;
}

textarea.bio-properties-panel-input {
  resize: vertical;
}

.bio-properties-panel-entry.has-error .bio-properties-panel-input,
.bio-properties-panel-entry.has-error .bio-properties-panel-feel-editor__open-popup-placeholder {
  border-color: var(--input-error-border-color);
  background-color: var(--input-error-background-color);
}

.bio-properties-panel-entry.has-error .bio-properties-panel-feel-indicator {
  border-color: var(--input-error-border-color);
}

.bio-properties-panel-entry.has-error .bio-properties-panel-input:focus,
.bio-properties-panel-entry.has-error .bio-properties-panel-feel-indicator:focus {
  border-color: var(--input-error-focus-border-color);
}

.bio-properties-panel-entry .bio-properties-panel-error {
  color: var(--text-error-color);
  margin: 4px 0;
  font-size: var(--text-size-small);
}

.bio-properties-panel-simple {
  width: 100%;
  margin-right: 8px;
}

.bio-properties-panel-simple + .bio-properties-panel-remove-entry {
  margin: auto;
}

/**
 * Toggle Switch
 */
.bio-properties-panel-toggle-switch-entry + .bio-properties-panel-toggle-switch-entry {
  margin-top: -8px;
}

.bio-properties-panel-toggle-switch-entry > .bio-properties-panel-description {
  margin-left: 38px;
}

.bio-properties-panel-toggle-switch .bio-properties-panel-field-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.bio-properties-panel-toggle-switch.inline {
  display: flex;
  flex-direction: row;
}

.bio-properties-panel-toggle-switch.inline .bio-properties-panel-field-wrapper {
  margin-left: auto;
}

.bio-properties-panel-toggle-switch > .bio-properties-panel-label {
  font-size: var(--text-size-base);
}

.bio-properties-panel-toggle-switch.inline > .bio-properties-panel-label {
  font-size: var(--text-size-small);
}

.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__label {
  margin: 0;
  margin-left: 6px;
  font-size: var(--text-size-base);
}

.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher {
  position: relative;
  width: 32px;
  height: 16px;
}

.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher:focus-within {
  outline: 2px solid var(--input-focus-border-color);
  outline-offset: 1px;
}

.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher input[type=checkbox] {
  opacity: 0;
  width: 0;
  height: 0;
}

.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher .bio-properties-panel-toggle-switch__slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--toggle-switch-off-background-color);
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;
}

.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher .bio-properties-panel-toggle-switch__slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 2px;
  bottom: 2px;
  background-color: var(--toggle-switch-switcher-background-color);
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
}

.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher input[type=checkbox]:checked + .bio-properties-panel-toggle-switch__slider {
  background-color: var(--toggle-switch-on-background-color);
  box-shadow: 0 0 1px;
}

.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher input[type=checkbox]:checked + .bio-properties-panel-toggle-switch__slider:before {
  -webkit-transform: translateX(16px);
  -ms-transform: translateX(16px);
  transform: translateX(16px);
}

/**
 * Collapsible entries
 */
.bio-properties-panel-collapsible-entry-entries {
  position: relative;
  display: none;
}

.bio-properties-panel-collapsible-entry-entries .bio-properties-panel-entry:last-child {
  padding-bottom: 0;
}

.bio-properties-panel-collapsible-entry-entries.open {
  display: block;
}

.bio-properties-panel-collapsible-entry-entries {
  padding-left: 20px;
  margin-bottom: 10px;
  position: relative;
  display: none;
}

.bio-properties-panel-collapsible-entry-header {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
}

.bio-properties-panel-collapsible-entry-header .bio-properties-panel-collapsible-entry-header-title {
  padding: 2px 24px 2px 32px;
  font-size: var(--text-size-base);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;
}

.bio-properties-panel-collapsible-entry-arrow {
  position: absolute;
  top: 2px;
  left: 6px;
  padding: 0 3px;
  height: 22px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: center;
}

.bio-properties-panel-remove-entry {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  padding: 0;
  width: 22px;
  height: 22px;
  fill: var(--remove-entry-fill-color);
  border-radius: 50%;
  border: none;
  background: none;
  visibility: hidden;
}

.bio-properties-panel-remove-entry:hover {
  background-color: var(--remove-entry-hover-background-color);
}

.bio-properties-panel-list-entry-item:hover .bio-properties-panel-remove-list-entry,
.bio-properties-panel-collapsible-entry:hover > .bio-properties-panel-collapsible-entry-header .bio-properties-panel-remove-entry,
.bio-properties-panel-collapsible-entry:focus-within > .bio-properties-panel-collapsible-entry-header .bio-properties-panel-remove-entry {
  visibility: visible;
}

/* Side line */
.bio-properties-panel-collapsible-entry-entries::before {
  content: "";
  position: absolute;
  left: 16px;
  width: 2px;
  top: -6px;
  bottom: 12px;
  background-color: var(--side-line-background-color);
  border-radius: 1px;
}

/* Side line extension for non-list entry or open list entry positioned as the last one. */
.bio-properties-panel-collapsible-entry-entries .bio-properties-panel-entry:not(.bio-properties-panel-list-entry):last-child,
.bio-properties-panel-list-entry.open:last-child {
  position: relative;
}

.bio-properties-panel-collapsible-entry-entries .bio-properties-panel-entry:not(.bio-properties-panel-list-entry):last-child::after,
.bio-properties-panel-list-entry.open:last-child::after {
  content: "";
  position: absolute;
  left: -16px;
  width: 2px;
  top: 0;
  bottom: -4px;
  background-color: var(--side-line-extension-background-color);
  border-radius: 1px;
}

.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry-entries .bio-properties-panel-entry:last-child::after {
  left: -18px;
}

/*
 * List entry
 */
.bio-properties-panel-list-entry {
  position: relative;
  margin-right: 5px;
  margin-bottom: 0;
}

.bio-properties-panel-list-entry .bio-properties-panel-entry {
  margin-right: 0;
}

.bio-properties-panel-list-entry-header {
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  height: 32px;
}

/* Nested list dot */
.bio-properties-panel-list-entry::before {
  content: "";
  width: 8px;
  height: 8px;
  position: absolute;
  left: -19px;
  top: 13px;
  border-radius: 50%;
  background-color: var(--list-entry-dot-background-color);
}

.bio-properties-panel-list-entry-header-title {
  display: block;
  margin: auto 0;
  padding: 2px 0;
  font-size: var(--text-size-base);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bio-properties-panel-list-entry-header-title.open {
  font-weight: 500;
}

.bio-properties-panel-list-entry-header-buttons {
  display: flex;
  align-items: center;
}

.bio-properties-panel-list-entry-header-buttons > button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  height: 22px;
  line-height: 22px;
  min-width: 22px;
  margin: 5px;
  padding: 0 3px;
  border: none;
  background: none;
  fill: var(--list-entry-header-button-fill-color);
}

.bio-properties-panel-list-entry-header-buttons > :last-child {
  margin-right: 0;
}

.bio-properties-panel-list-entry-items {
  padding: 0;
  margin: 0;
  list-style: none;
}

.bio-properties-panel-list-entry-items:not(.open) {
  display: none;
}

.bio-properties-panel-list-entry-item {
  display: flex;
  justify-content: space-between;
}

.bio-properties-panel-list-entry-item .bio-properties-panel-remove-entry {
  margin-right: 1px;
}

.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry {
  width: 100%;
  margin-right: 4px;
}

.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry-header {
  margin-left: -8px;
}

.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry-arrow {
  left: 2px;
}

.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry-header-title {
  padding-left: 30px;
}

.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry-entries {
  padding-left: 10px;
}

.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry-entries::before {
  left: 4px;
}

.bio-properties-panel-list-entry.empty .bio-properties-panel-add-entry {
  margin-right: 16px;
  padding-left: 6px;
}

.bio-properties-panel-list-entry.empty .bio-properties-panel-add-entry-label {
  color: var(--list-entry-add-entry-label-color);
  padding: 4px 6px 3px 2px;
}

.bio-properties-panel-list-entry-header-buttons .bio-properties-panel-add-entry:hover {
  background-color: var(--list-entry-add-entry-background-color);
  fill: var(--list-entry-add-entry-fill-color);
}

.bio-properties-panel-list-entry-item .bio-properties-panel-simple .bio-properties-panel-input {
  border-radius: 0;
  margin-bottom: -2px;
}

.bio-properties-panel-list-entry-item:first-child .bio-properties-panel-simple .bio-properties-panel-input {
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
}

.bio-properties-panel-list-entry-item:last-child .bio-properties-panel-simple .bio-properties-panel-input {
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
}

.bio-properties-panel-dropdown-button {
  position: relative;
  --dropdown-button-margin: 5px;
}

.bio-properties-panel-dropdown-button:not(.open) .bio-properties-panel-dropdown-button__menu {
  display: none;
}

.bio-properties-panel-dropdown-button__menu {
  min-width: calc(100% - var(--dropdown-button-margin) * 2);
  max-width: 240px;
  position: absolute;
  top: calc(100% - var(--dropdown-button-margin));
  right: var(--dropdown-button-margin);
  z-index: 101;
  background-color: var(--dropdown-item-background-color);
  padding: 8px 0;
  box-shadow: 0 1px 4px 0 var(--color-grey-225-10-85), 0 2px 16px 0 var(--color-grey-225-10-75);
}

.bio-properties-panel-dropdown-button__menu-item {
  display: block;
  width: 100%;
  padding: 4px 12px;
  font-size: var(--text-size-small);
  appearance: revert;
  border: unset;
  background: unset;
  text-align: unset;
}

.bio-properties-panel-dropdown-button__menu-item--separator {
  width: 100%;
  height: 1px;
  padding: 0;
  margin: 8px 0;
  background-color: var(--dropdown-separator-background-color);
}

.bio-properties-panel-dropdown-button__menu-item--actionable {
  font-size: var(--text-size-base);
}

.bio-properties-panel-dropdown-button__menu-item--actionable:hover {
  background-color: var(--dropdown-item-hover-background-color);
}

.bio-properties-panel-feel-input {
  position: relative;
}

.bio-properties-panel-feel-input input {
  padding-right: 2em;
}

.bio-properties-panel-feel-entry .bio-properties-panel-label {
  display: flex;
}

.bio-properties-panel-feel-icon {
  display: inline-flex;
  height: 18px;
  width: 22px;
  vertical-align: text-bottom;
  padding: 0;
  margin: 0 3px;
  align-items: center;
  align-self: center;
  justify-content: center;
  border: none;
  background: none;
  border-radius: 3px;
}

.bio-properties-panel-feel-icon.optional {
  cursor: pointer;
  background: var(--feel-background-color);
}

.bio-properties-panel-feel-icon svg * {
  fill: var(--feel-inactive-color);
}

.bio-properties-panel-feel-icon:hover {
  background: var(--feel-hover-background-color);
}

.bio-properties-panel-feel-icon:hover svg * {
  fill: var(--feel-hover-color);
}

.bio-properties-panel-feel-icon.active {
  background: var(--feel-active-background-color);
}

.bio-properties-panel-feel-icon.active:hover {
  background: var(--feel-hover-background-color);
}

.bio-properties-panel-feel-icon.required.active {
  background: none;
}

.bio-properties-panel-feel-icon.active svg * {
  fill: var(--feel-active-color);
}

.bio-properties-panel-feel-icon.required.active svg * {
  fill: var(--feel-required-color);
}

.bio-properties-panel-feel-editor-container {
  position: relative;
}

.bio-properties-panel-feel-editor-container.active {
  font-family: var(--font-family-monospace);
}

.bio-properties-panel-feel-container {
  position: relative;
}

.bio-properties-panel-feel-container .bio-properties-panel-feel-editor-container > div {
  position: static;
  padding-left: 2.4em !important;
  min-height: 28px;
}

.bio-properties-panel-feel-indicator {
  position: absolute;
  border: 1px solid var(--input-border-color);
  background-color: var(--feel-indicator-background-color);
  border-right: 0px;
  border-radius: 2px 0 0 2px;
  z-index: 1;
  height: 100%;
  width: 2em;
  text-align: center;
  padding: 2px 6px;
}

.bio-properties-panel-feel-editor-container .cm-scroller {
  overflow: hidden !important;
}

.bio-properties-panel-feelers-editor .cm-editor {
  background-color: transparent;
}

/* @Note(pinussilvestrus): mitigate low contrast - https://github.com/bpmn-io/cm-theme/issues/4 */
.bio-properties-panel-feelers-editor .cm-content ::selection {
  background: var(--feelers-select-color, hsl(205, 100%, 85%));
}

.bio-properties-panel-feelers-editor .cm-editor.cm-focused {
  background-color: transparent;
}

.bio-properties-panel-feel-editor-container .bio-properties-panel-input {
  resize: none;
  overflow: hidden;
  overflow-y: auto;
}

.bio-properties-panel-feel-editor-container,
.bio-properties-panel-feel-editor-container .bio-properties-panel-input,
.bio-properties-panel-feel-container .cm-editor {
  min-height: 100%;
}

.bio-properties-panel-feel-checkbox,
.bio-properties-panel-feel-toggle-switch {
  padding-top: 1px;
}

.bio-properties-panel-feel-checkbox .bio-properties-panel-feel-entry:not(.feel-active),
.bio-properties-panel-feel-toggle-switch .bio-properties-panel-feel-entry:not(.feel-active) {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.bio-properties-panel-feel-checkbox .bio-properties-panel-feel-entry:not(.feel-active) .bio-properties-panel-feel-container,
.bio-properties-panel-feel-toggle-switch .bio-properties-panel-feel-entry:not(.feel-active) .bio-properties-panel-feel-container {
  margin-left: auto;
}

.bio-properties-panel-tooltip-wrapper {
  text-decoration: underline;
  text-decoration-style: dotted;
  text-underline-offset: 2px;
  font: inherit;
  display: flex;
  justify-content: center;
  width: fit-content;
}

.bio-properties-panel-tooltip {
  --tooltip-underline-color: var(--color-blue-219-99-53);
  --tooltip-background-color: var(--color-grey-0-0-22);
  --tooltip-link: var(--color-blue-218-100-74);
  --tooltip-code-background-color: var(--color-grey-225-10-97);
  --tooltip-code-border-color: var(--color-grey-225-10-85);
  display: flex;
  color: var(--color-white, white);
  position: fixed;
  z-index: 1000;
  max-width: 300px;
  font-size: var(--text-size-small);
  font-family: var(--font-family);
}

.bio-properties-panel-tooltip.right {
  padding-right: 6px;
}

.bio-properties-panel-tooltip.top {
  flex-direction: column;
}

.bio-properties-panel-tooltip-content {
  background-color: var(--tooltip-background-color);
  padding: 16px;
  border-radius: 2px;
  font-weight: 400;
  white-space: pre-wrap;
}

.bio-properties-panel-tooltip-content h1 {
  font-size: var(--text-size-base);
  font-weight: bold;
  margin: 0;
}

.bio-properties-panel-tooltip-content code,
.bio-properties-panel-tooltip-content pre {
  color: var(--description-color);
  font-family: var(--font-family);
  font-size: var(--text-size-small);
  line-height: var(--line-height-condensed);
  padding: 0 2px;
  background-color: var(--tooltip-code-background-color);
  border: 1px solid var(--tooltip-code-border-color);
  border-radius: 3px;
}

.bio-properties-panel-tooltip-content pre code {
  border: none;
}

.bio-properties-panel-tooltip p:first-child {
  margin-top: 0;
}

.bio-properties-panel-tooltip p:last-child {
  margin-bottom: 0;
}

.bio-properties-panel-tooltip-content a {
  color: var(--tooltip-link);
}

.bio-properties-panel-tooltip .bio-properties-panel-tooltip-arrow {
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 5px solid var(--tooltip-background-color);
  margin-top: 16px;
}

.bio-properties-panel-tooltip.top .bio-properties-panel-tooltip-arrow {
  margin-top: -3px;
  margin-left: calc(50% - 2.5px);
  transform: rotate(90deg);
}

.bio-properties-panel-feelers-editor-container .bio-properties-panel-feelers-editor__open-popup-placeholder,
.bio-properties-panel-feel-editor-container .bio-properties-panel-feel-editor__open-popup-placeholder {
  display: none;
  justify-content: center;
  flex-direction: column;
  color: hsla(0, 0%, 9%, 0.25);
  padding: 3px 6px 2px;
  border: 1px solid var(--input-border-color);
  border-radius: 2px;
  background-color: var(--input-background-color);
  font-size: var(--text-size-base);
  font-family: inherit;
  width: 100%;
  min-height: 100%;
}

.bio-properties-panel-feelers-editor-container.popupOpen .bio-properties-panel-input,
.bio-properties-panel-feel-editor-container.popupOpen .bio-properties-panel-input {
  display: none;
}

.bio-properties-panel-feelers-editor-container.popupOpen .bio-properties-panel-feelers-editor__open-popup-placeholder,
.bio-properties-panel-feel-editor-container.popupOpen .bio-properties-panel-feel-editor__open-popup-placeholder {
  display: flex;
}

.bio-properties-panel-popup {
  --popup-background-color: hsla(0, 0%, 96%, 1);
  --popup-header-background-color: white;
  --popup-font-color: hsla(0, 0%, 0%, 1);
  --popup-title-color: hsla(0, 0%, 0%, 1);
  --feel-popup-close-background-color: hsla(219, 99%, 53%, 1);
  --feel-popup-gutters-background-color: hsla(0, 0%, 90%, 1);
  position: fixed;
  display: flex;
  flex: auto;
  flex-direction: column;
  font-family: IBM Plex Sans, sans-serif;
  padding: 0;
  z-index: 1001;
  box-shadow: 0px 2px 6px 0px hsla(0, 0%, 0%, 0.3);
  background-color: var(--popup-background-color);
  color: var(--popup-font-color);
  height: auto;
  width: auto;
  overflow: hidden;
  font-size: 14px;
}

.bio-properties-panel-popup h1,
.bio-properties-panel-popup h2,
.bio-properties-panel-popup h3,
.bio-properties-panel-popup h4 {
  font-weight: 500;
  font-size: inherit;
}

.bio-properties-panel-popup .bio-properties-panel-popup__header,
.bio-properties-panel-popup .bio-properties-panel-popup__body,
.bio-properties-panel-popup .bio-properties-panel-popup__footer {
  padding: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bio-properties-panel-popup .bio-properties-panel-popup__body:not(:first-child) {
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
}

.bio-properties-panel-popup .bio-properties-panel-popup__header {
  --popup-header-line-height: 16px;
  background-color: var(--popup-header-background-color);
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  line-height: var(--popup-header-line-height);
  text-align: left;
  color: var(--popup-title-color);
}

.bio-properties-panel-popup .bio-properties-panel-popup__header.draggable {
  cursor: grab;
}

.bio-properties-panel-popup .bio-properties-panel-popup__drag-handle {
  display: flex;
}

.bio-properties-panel-popup .bio-properties-panel-popup__drag-preview {
  width: 1px;
  height: 1px;
  position: absolute;
  top: 0;
}

.bio-properties-panel-popup .bio-properties-panel-popup__title {
  margin-left: 8px;
}

.bio-properties-panel-popup .bio-properties-panel-popup__title::first-letter {
  text-transform: capitalize;
}

.bio-properties-panel-popup .bio-properties-panel-popup__close {
  margin: -12px;
  margin-left: 12px;
  width: 40px;
  height: 40px;
  border: none;
  background-color: var(--popup-header-background-color);
}

.bio-properties-panel-popup .bio-properties-panel-popup__close:hover,
.bio-properties-panel-popup .bio-properties-panel-popup__close:focus-visible {
  background-color: var(--popup-background-color);
}

.bio-properties-panel-popup .bio-properties-panel-popup__close:focus-visible {
  outline-offset: -2px;
}

.bio-properties-panel-popup .bio-properties-panel-popup__close svg {
  width: 16px;
  height: 16px;
  fill: currentColor;
  margin-top: 2px;
}

.bio-properties-panel-popup .bio-properties-panel-popup__header .bio-properties-panel-popup__drag-handle svg {
  margin-left: -4px;
}

.bio-properties-panel-popup .bio-properties-panel-popup__body {
  font-size: inherit;
  height: 100%;
  display: flex;
  overflow: auto;
  padding-bottom: 0;
}

.bio-properties-panel-popup .bio-properties-panel-popup__footer {
  position: absolute;
  bottom: 0;
  right: 8px;
}

.bio-properties-panel-feel-popup {
  min-height: 400px;
  width: fit-content;
}

.bio-properties-panel-feel-popup .bio-properties-panel-feel-popup__body {
  display: flex;
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}

.bio-properties-panel-feel-popup__title-link {
  margin-left: 8px;
  display: flex;
}

.bio-properties-panel-feel-popup__title-link:first-of-type {
  margin-left: auto;
}

.bio-properties-panel-feel-popup__title-link svg {
  width: var(--popup-header-line-height);
  height: var(--popup-header-line-height);
  fill: currentColor;
  margin: 0 0.5em;
}

.bio-properties-panel-feel-popup .bio-properties-panel-feel-editor-container {
  display: flex;
  min-width: 100%;
}

.bio-properties-panel-feel-popup .bio-properties-panel-feel-editor-container .cm-scroller {
  overflow: auto !important;
}

.bio-properties-panel-feel-popup .bio-properties-panel-feelers-editor-container {
  width: 100%;
  display: flex;
}

.bio-properties-panel-feel-popup .bio-properties-panel-feelers-editor-container .bio-properties-panel-feelers-editor {
  display: flex;
}

.bio-properties-panel-feel-popup .bio-properties-panel-feelers-editor-container .bio-properties-panel-feelers-editor .cm-editor {
  width: 100%;
}

.bio-properties-panel-feel-popup .bio-properties-panel-input {
  width: 100%;
  resize: none;
  padding: 0;
  overflow: hidden;
  overflow-y: auto;
}

.bio-properties-panel-feel-popup .bio-properties-panel-open-feel-popup {
  display: none !important;
}

.bio-properties-panel-feelers-editor-container .bio-properties-panel-open-feel-popup,
.bio-properties-panel-feel-container .bio-properties-panel-open-feel-popup {
  position: absolute;
  top: 0;
  right: 0;
  line-height: 1;
  padding: 2px 4px;
  margin: 3px;
  display: none;
  background: none;
  border: none;
  color: var(--feel-open-popup-color);
  cursor: pointer;
}

.bio-properties-panel-feelers-editor-container:hover .bio-properties-panel-open-feel-popup,
.bio-properties-panel-feel-container:hover .bio-properties-panel-open-feel-popup,
.bio-properties-panel-feelers-editor-container:focus-within .bio-properties-panel-open-feel-popup,
.bio-properties-panel-feel-container:focus-within .bio-properties-panel-open-feel-popup {
  display: block;
}

.bio-properties-panel-feelers-editor-container .bio-properties-panel-open-feel-popup:hover,
.bio-properties-panel-feel-container .bio-properties-panel-open-feel-popup:hover {
  color: var(--feel-open-popup-hover-color);
}

.bio-properties-panel-feel-popup .bio-properties-panel-popup__footer .bio-properties-panel-feel-popup__close-btn {
  background: var(--feel-popup-close-background-color);
  width: 66px;
  font-weight: 400;
  font-size: 14px;
  font-family: inherit;
  color: white;
  border: none;
  height: 32px;
  cursor: pointer;
}

.bio-properties-panel-feel-popup .bio-properties-panel-feel-editor-container .cm-editor {
  width: 100%;
  height: 100%;
}

.bio-properties-panel-feel-popup .bio-properties-panel-feel-editor-container .cm-editor .cm-content {
  padding-left: 4px;
}

.bio-properties-panel-feel-popup .bio-properties-panel-input {
  border: none;
}

.bio-properties-panel-feel-popup .cm-gutters {
  background-color: var(--feel-popup-gutters-background-color);
  border: none;
  padding: 0;
}

.bio-properties-panel-feel-popup .cm-gutter {
  min-width: 32px;
}

.bio-properties-panel-feel-popup .cm-gutters .cm-lineNumbers .cm-gutterElement {
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@bpmn-io/form-js/dist/assets/form-js-editor.css"],"names":[],"mappings":"AAAA;EACE,6FAA6F;EAC7F,iDAAiD;EACjD,6FAA6F;EAC7F,gDAAgD;EAChD,qFAAqF;EACrF,gEAAgE;EAChE,6FAA6F;EAC7F,yFAAyF;EACzF,8EAA8E;EAC9E,mFAAmF;EACnF,4EAA4E;EAC5E,iHAAiH;EACjH,6DAA6D;EAC7D,gFAAgF;AAClF;;AAEA;EACE,0EAA0E;EAC1E,wFAAwF;EACxF,oHAAoH;EACpH,kEAAkE;EAClE,qFAAqF;EACrF,iHAAiH;EACjH,iDAAiD;EACjD,mFAAmF;EACnF,uFAAuF;EACvF,4FAA4F;EAC5F,iHAAiH;EACjH,4GAA4G;EAC5G,mFAAmF;EACnF,wFAAwF;EACxF,sDAAsD;EACtD,gDAAgD;EAChD,2FAA2F;EAC3F,gHAAgH;EAChH,wFAAwF;EACxF,gGAAgG;EAChG;;;GAGC;EACD,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,kFAAkF;EAClF;;;GAGC;EACD,+BAA+B;AACjC;;AAEA;;EAEE;AACF;EACE,uEAAuE;EACvE,sEAAsE;EACtE,mEAAmE;EACnE,2EAA2E;EAC3E,uGAAuG;EACvG,mHAAmH;EACnH,qFAAqF;EACrF,6EAA6E;EAC7E,kGAAkG;EAClG,6FAA6F;EAC7F,8EAA8E;EAC9E,yDAAyD;EACzD,mEAAmE;EACnE,+GAA+G;EAC/G,mGAAmG;EACnG;;;GAGC;EACD,8EAA8E;EAC9E,yEAAyE;EACzE,wFAAwF;EACxF,oEAAoE;EACpE,sDAAsD;EACtD,kEAAkE;EAClE,0EAA0E;EAC1E,kGAAkG;EAClG,mEAAmE;EACnE,+DAA+D;EAC/D,yFAAyF;EACzF,4FAA4F;EAC5F,wGAAwG;EACxG,mGAAmG;EACnG,0EAA0E;EAC1E,kGAAkG;EAClG,8EAA8E;EAC9E,oFAAoF;EACpF,6EAA6E;EAC7E,qGAAqG;EACrG,sFAAsF;EACtF,yFAAyF;EACzF,wFAAwF;EACxF,oFAAoF;EACpF,oFAAoF;EACpF,2FAA2F;EAC3F,6FAA6F;EAC7F,iGAAiG;EACjG,mGAAmG;EACnG,yGAAyG;EACzG,+EAA+E;EAC/E,6FAA6F;EAC7F,8EAA8E;EAC9E,oCAAoC;EACpC,yEAAyE;EACzE,6EAA6E;EAC7E,wEAAwE;EACxE,+EAA+E;EAC/E,2CAA2C;EAC3C,4EAA4E;EAC5E,2FAA2F;AAC7F;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,8DAA8D;EAC9D,2DAA2D;EAC3D,mBAAmB;AACrB;;AAEA;;EAEE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;EAKE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,mDAAmD;EACnD,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;;;EAGE,iDAAiD;AACnD;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,iCAAiC;EACjC,8DAA8D;EAC9D,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gDAAgD;AAChD;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;;EAEE;AACF;EACE,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE;AACF;EACE,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,0DAA0D;EAC1D,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,wDAAwD;EACxD,kBAAkB;AACpB;;AAEA;;EAEE;AACF;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,2DAA2D;EAC3D,6DAA6D;EAC7D,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;EAClB,2DAA2D;EAC3D,kDAAkD;EAClD,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kCAAkC;EAClC,oDAAoD;EACpD,wDAAwD;EACxD,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,0DAA0D;AAC5D;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,iCAAiC;EACjC,uDAAuD;EACvD,oDAAoD;EACpD,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mDAAmD;AACrD;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,0DAA0D;EAC1D,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gCAAgC;AAClC;;AAEA;;EAEE;AACF;EACE,iCAAiC;EACjC,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE;AACF;EACE,YAAY;AACd;;AAEA;EACE,8DAA8D;EAC9D,oCAAoC;EACpC,+DAA+D;EAC/D,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE;AACF;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,+FAA+F;AACjG;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE;AACF;EACE,sDAAsD;EACtD,yDAAyD;EACzD,6BAA6B;EAC7B,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,0CAA0C;EAC1C,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,uBAAuB;EACvB,4DAA4D;EAC5D,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mEAAmE;EACnE,+DAA+D;EAC/D,6BAA6B;EAC7B,uDAAuD;EACvD,wBAAwB;EACxB,uBAAuB;EACvB,8BAA8B;EAC9B,kCAAkC;EAClC,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;EACrB,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,uBAAuB;EACvB,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,wBAAwB;EACxB,YAAY;EACZ,iEAAiE;EACjE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,iEAAiE;EACjE,yBAAyB;AAC3B;;AAEA;;EAEE;AACF;;EAEE,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,oCAAoC;EACpC,4CAA4C;EAC5C,4CAA4C;EAC5C,2CAA2C;EAC3C,4CAA4C;EAC5C,4CAA4C;EAC5C,0CAA0C;EAC1C,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,oBAAoB;EACpB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,8CAA8C;EAC9C,+CAA+C;EAC/C,0CAA0C;EAC1C,gDAAgD;EAChD,gEAAgE;EAChE,4DAA4D;EAC5D,0DAA0D;EAC1D,gDAAgD;EAChD,2DAA2D;EAC3D,sDAAsD;EACtD,qDAAqD;EACrD,yDAAyD;EACzD,4CAA4C;EAC5C,wDAAwD;EACxD,4DAA4D;EAC5D,+DAA+D;EAC/D,mDAAmD;EACnD,gDAAgD;EAChD,gEAAgE;EAChE,2CAA2C;EAC3C,sDAAsD;EACtD,kEAAkE;EAClE,+CAA+C;EAC/C,2DAA2D;EAC3D,wCAAwC;EACxC,8CAA8C;EAC9C,sCAAsC;EACtC,0DAA0D;EAC1D,qDAAqD;EACrD,iDAAiD;EACjD,4DAA4D;EAC5D,wDAAwD;EACxD,mDAAmD;EACnD,2DAA2D;EAC3D,uDAAuD;EACvD,6DAA6D;EAC7D,mDAAmD;EACnD,8DAA8D;EAC9D,0DAA0D;EAC1D,iEAAiE;EACjE,iEAAiE;EACjE,6DAA6D;EAC7D,yDAAyD;EACzD,mEAAmE;EACnE,8DAA8D;EAC9D,kEAAkE;EAClE,2EAA2E;EAC3E,iFAAiF;EACjF,sDAAsD;EACtD,qEAAqE;EACrE,qDAAqD;EACrD,oDAAoD;EACpD,mEAAmE;EACnE,kEAAkE;EAClE,oCAAoC;EACpC,iDAAiD;EACjD,kDAAkD;EAClD,+CAA+C;EAC/C,0DAA0D;EAC1D,2CAA2C;EAC3C,kDAAkD;EAClD,4CAA4C;EAC5C,sDAAsD;EACtD,qDAAqD;EACrD,8DAA8D;EAC9D,oDAAoD;EACpD,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,wBAAwB;EACxB,6BAA6B;EAC7B,yBAAyB;EACzB,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE;AACF;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,qDAAqD;AACvD;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE;AACF;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,gDAAgD;EAChD,0DAA0D;EAC1D,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE;AACF;EACE,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;AACT;;AAEA;;EAEE;AACF;EACE,+CAA+C;EAC/C,yDAAyD;EACzD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB,EAAE,yBAAyB;EAC9C,kBAAkB,EAAE,mCAAmC;EACvD,wBAAwB,EAAE,eAAe;EACzC,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sDAAsD;EACtD,gEAAgE;AAClE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,yDAAyD;EACzD,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE;AACF;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;;EAEE;AACF;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;;;;EAIE,+BAA+B;EAC/B,cAAc;EACd,iBAAiB;EACjB,yCAAyC;EACzC,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,iCAAiC;EACjC,yCAAyC;EACzC,cAAc;EACd,0DAA0D;EAC1D,sDAAsD;EACtD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,2CAA2C;EAC3C,kBAAkB;EAClB,+CAA+C;EAC/C,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;;;;EAIE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,qDAAqD;EACrD,iDAAiD;AACnD;;AAEA;;EAEE,6DAA6D;EAC7D,qDAAqD;AACvD;;AAEA;EACE,gDAAgD;EAChD,wDAAwD;EACxD,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,6CAA6C;EAC7C,qDAAqD;AACvD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;;EAEE,mDAAmD;AACrD;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE;AACF;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2DAA2D;EAC3D,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,gEAAgE;EAChE,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0DAA0D;EAC1D,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;;EAEE;AACF;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,SAAS;EACT,YAAY;EACZ,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA,0FAA0F;AAC1F;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,MAAM;EACN,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE;AACF;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,cAAc;EACd,cAAc;EACd,cAAc;EACd,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;EAC9C,wBAAwB;AAC1B;;AAEA;EACE,8DAA8D;EAC9D,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yDAAyD;EACzD,gBAAgB;EAChB,kBAAkB;EAClB,+CAA+C;EAC/C,oCAAoC;EACpC,YAAY;EACZ,uDAAuD;EACvD,cAAc;EACd,6FAA6F;AAC/F;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,UAAU;EACV,aAAa;EACb,4DAA4D;AAC9D;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,wDAAwD;EACxD,iBAAiB;EACjB,0BAA0B;EAC1B,UAAU;EACV,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,iGAAiG;AACjG;EACE,4DAA4D;AAC9D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,sDAAsD;EACtD,oDAAoD;EACpD,4CAA4C;EAC5C,4DAA4D;EAC5D,wDAAwD;EACxD,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iDAAiD;EACjD,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,SAAS;AACX;;AAEA;;EAEE,+BAA+B;EAC/B,+BAA+B;EAC/B,iCAAiC;EACjC,yCAAyC;EACzC,cAAc;EACd,sDAAsD;EACtD,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,oCAAoC;EACpC,sDAAsD;EACtD,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;EAC5B,oBAAoB;EACpB,2CAA2C;EAC3C,kBAAkB;EAClB,+CAA+C;EAC/C,gCAAgC;EAChC,oBAAoB;EACpB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,6CAA6C;EAC7C,sCAAsC;EACtC,sCAAsC;EACtC,uCAAuC;EACvC,2DAA2D;EAC3D,0DAA0D;EAC1D,eAAe;EACf,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,sCAAsC;EACtC,UAAU;EACV,aAAa;EACb,gDAAgD;EAChD,+CAA+C;EAC/C,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;EAIE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,sDAAsD;EACtD,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,4CAA4C;EAC5C,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sDAAsD;AACxD;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,mCAAmC;EACnC,eAAe;AACjB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;EACpD,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4DAA4D;EAC5D,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".fjs-editor-container {\n  --color-children-selected-border: var(--cds-border-interactive, var(--color-blue-219-100-53));\n  --color-children-selected-background: transparent;\n  --color-children-hover-border: var(--cds-border-interactive, var(--color-blue-219-100-53-05));\n  --color-context-pad-item-background: transparent;\n  --color-context-pad-item-fill: var(--cds-icon-secondary, var(--color-grey-225-10-15));\n  --color-context-pad-item-hover-fill: var(--color-red-360-100-45);\n  --color-resize-handle-background: var(--cds-border-interactive, var(--color-blue-219-100-53));\n  --color-resize-handle-border: var(--cds-border-interactive, var(--color-blue-219-100-53));\n  --color-dragula-background: var(--cds-highlight, var(--color-blue-205-100-95));\n  --color-dragula-border: var(--cds-border-interactive, var(--color-blue-205-100-45));\n  --color-dragula-mirror-background: var(--cds-background, var(--color-white));\n  --color-dragula-mirror-border: var(--cds-border-strong, var(--cds-border-strong-01, var(--color-grey-225-10-90)));\n  --color-dragula-error-background: var(--color-red-360-100-92);\n  --color-dragula-error-border: var(--cds-text-error, var(--color-red-360-100-45));\n}\n\n.fjs-palette-container {\n  --color-palette-text: var(--cds-text-primary, var(--color-grey-225-10-15));\n  --color-palette-container-background: var(--cds-background, var(--color-grey-225-10-95));\n  --color-palette-container-border: var(--cds-border-strong, var(--cds-border-strong-01, var(--color-grey-225-10-80)));\n  --color-palette-header: var(--cds-text-primary, var(--color-text));\n  --color-palette-header-background: var(--cds-background, var(--color-grey-225-10-95));\n  --color-palette-header-border: var(--cds-border-strong, var(--cds-border-strong-01, var(--color-grey-225-10-85)));\n  --color-palette-search: var(--color-palette-text);\n  --color-palette-search-icon: var(--cds-icon-secondary, var(--color-grey-225-10-35));\n  --color-palette-search-icon-hover: var(--cds-icon-primary, var(--color-grey-225-10-15));\n  --color-palette-search-background: var(--cds-field, var(--cds-field-01, var(--color-white)));\n  --color-palette-search-border: var(--cds-border-strong, var(--cds-border-strong-01, var(--color-grey-225-10-75)));\n  --color-palette-search-focus-background: var(--cds-field, var(--cds-field-01, var(--color-blue-205-100-95)));\n  --color-palette-search-focus-border: var(--cds-focus, var(--color-blue-205-100-50));\n  --color-palette-search-clear-focus-border: var(--cds-focus, var(--color-grey-225-10-50));\n  --color-palette-group-title: var(--color-palette-text);\n  --color-palette-field: var(--color-palette-text);\n  --color-palette-field-background: var(--cds-layer, var(--cds-layer-01, var(--color-white)));\n  --color-palette-field-border: var(--cds-border-subtle, var(--cds-border-subtle-01, var(--color-grey-225-10-93)));\n  --color-palette-field-focus: var(--cds-border-interactive, var(--color-blue-205-100-45));\n  --color-palette-field-hover-background: var(--cds-background-hover, var(--color-grey-225-10-90));\n  --color-palette-field-hover-border: var(\n    --cds-border-strong,\n    var(--cds-border-strong-01, var(--color-grey-225-10-55))\n  );\n  --cursor-palette-field: grab;\n  --palette-width: 270px;\n}\n\n.fjs-properties-container {\n  --color-properties-container-background: var(--cds-background, var(--color-white));\n  --color-properties-container-border: var(\n    --cds-border-strong,\n    var(--cds-border-strong-01, var(--color-grey-225-10-80))\n  );\n  --properties-panel-width: 300px;\n}\n\n/**\n * Theming overrides\n */\n.fjs-properties-container .bio-properties-panel {\n  --text-base-color: var(--cds-text-primary, var(--color-grey-225-10-15));\n  --text-error-color: var(--cds-text-color, var(--color-red-360-100-45));\n  --link-color: var(--cds-text-primary, var(--color-blue-205-100-50));\n  --description-color: var(--cds-text-secondary, var(--color-grey-225-10-35));\n  --description-code-background-color: var(--cds-layer, var(--cds-layer-01, var(--color-grey-225-10-97)));\n  --description-code-border-color: var(--cds-border-strong, var(--cds-border-strong-01, var(--color-grey-225-10-85)));\n  --description-list-item-color: var(--cds-text-secondary, var(--color-grey-225-10-35));\n  --placeholder-color: var(--cds-text-placeholder, var(--color-grey-225-10-35));\n  --placeholder-background-color: var(--cds-layer, var(--cds-layer-01, var(--color-grey-225-10-95)));\n  --header-background-color: var(--cds-layer, var(--cds-layer-01, var(--color-grey-225-10-95)));\n  --header-icon-fill-color: var(--cds-icon-primary, var(--color-grey-225-10-15));\n  --header-bottom-border-color: var(--color-grey-225-10-75);\n  --group-background-color: var(--cds-background, var(--color-white));\n  --group-bottom-border-color: var(--cds-border-strong, var(--cds-border-strong-01, var(--color-grey-225-10-75)));\n  --sticky-group-background-color: var(--cds-layer, var(--cds-layer-01, var(--color-grey-225-10-95)));\n  --sticky-group-bottom-border-color: var(\n    --cds-border-strong,\n    var(--cds-border-strong-01, var(--color-grey-225-10-75))\n  );\n  --add-entry-fill-color: var(--cds-icon-secondary, var(--color-grey-225-10-35));\n  --add-entry-hover-fill-color: var(--cds-icon-inverse, var(--color-white));\n  --add-entry-hover-background-color: var(--cds-interactive, var(--color-blue-205-100-50));\n  --add-entry-label-color: var(--cds-text-inverse, var(--color-white));\n  --remove-entry-fill-color: var(--color-red-360-100-45);\n  --remove-entry-hover-background-color: var(--color-red-360-100-92);\n  --arrow-fill-color: var(--cds-icon-secondary, var(--color-grey-225-10-35));\n  --arrow-hover-background-color: var(--cds-layer, var(--cds-layer-01, var(--color-grey-225-10-95)));\n  --dot-color: var(--cds-text-secondary, var(--color-grey-225-10-35));\n  --list-badge-color: var(--cds-text-inverse, var(--color-white));\n  --list-badge-background-color: var(--cds-background-inverse, var(--color-grey-225-10-35));\n  --input-background-color: var(--cds-field, var(--cds-field-01, var(--color-grey-225-10-97)));\n  --input-border-color: var(--cds-border-strong, var(--cds-border-strong-01, var(--color-grey-225-10-75)));\n  --input-focus-background-color: var(--cds-field, var(--cds-field-01, var(--color-blue-205-100-95)));\n  --input-focus-border-color: var(--cds-focus, var(--color-blue-205-100-50));\n  --input-error-background-color: var(--cds-field, var(--cds-field-01, var(--color-red-360-100-97)));\n  --input-error-border-color: var(--cds-text-error, var(--color-red-360-100-45));\n  --input-error-focus-border-color: var(--cds-text-error, var(--color-red-360-100-45));\n  --input-disabled-color: var(--cds-text-disabled, var(--color-grey-225-10-55));\n  --input-disabled-background-color: var(--cds-field, var(--cds-field-01, var(--color-grey-225-10-97)));\n  --input-disabled-border-color: var(--cds-border-disabled, var(--color-grey-225-10-90));\n  --toggle-switch-on-background-color: var(--cds-interactive, var(--color-blue-205-100-50));\n  --toggle-switch-off-background-color: var(--cds-toggle-off, var(--color-grey-225-10-75));\n  --toggle-switch-switcher-background-color: var(--cds-background, var(--color-white));\n  --side-line-background-color: var(--cds-text-secondary, var(--color-grey-225-10-35));\n  --side-line-extension-background-color: var(--cds-text-secondary, (--color-grey-225-10-35));\n  --list-entry-dot-background-color: var(--cds-background-inverse, var(--color-grey-225-10-35));\n  --list-entry-header-button-fill-color: var(--cds-background-inverse, var(--color-grey-225-10-35));\n  --list-entry-add-entry-empty-background-color: var(--cds-interactive, var(--color-blue-205-100-50));\n  --list-entry-add-entry-empty-hover-background-color: var(--cds-interactive, var(--color-blue-205-100-45));\n  --list-entry-add-entry-label-color: var(--cds-text-inverse, var(--color-white));\n  --list-entry-add-entry-background-color: var(--cds-interactive, var(--color-blue-205-100-50));\n  --list-entry-add-entry-fill-color: var(--cds-icon-inverse, var(--color-white));\n  --feel-background-color: transparent;\n  --feel-active-color: var(--cds-interactive, var(--color-blue-205-100-45));\n  --feel-inactive-color: var(--cds-icon-secondary, var(--color-grey-225-10-35));\n  --feel-hover-color: var(--cds-icon-primary, var(--color-grey-225-10-15));\n  --feel-hover-background-color: var(--cds-layer-02, var(--color-grey-225-10-97));\n  --feel-active-background-color: transparent;\n  --feel-required-color: var(--cds-icon-disabled, var(--color-grey-225-10-55));\n  --feel-indicator-background-color: var(--cds-background-hover, var(--color-grey-225-10-90));\n}\n\n.fjs-properties-container .bio-properties-panel-input {\n  color: var(--color-text);\n}\n\n.fjs-editor-container {\n  height: 100%;\n  width: 100%;\n  display: flex;\n}\n\n.fjs-editor-container .fjs-form-editor {\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n}\n\n.fjs-editor-container .fjs-form-container {\n  overflow-y: auto;\n  position: relative;\n}\n\n.fjs-editor-container .fjs-render-injector-container {\n  width: 0;\n  height: 0;\n  display: none;\n  overflow: hidden;\n}\n\n.fjs-editor-container .fjs-form-container,\n.fjs-editor-container .fjs-form {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.fjs-editor-container .fjs-form > .fjs-element {\n  flex-grow: 1;\n}\n\n.fjs-editor-container .fjs-children .fjs-children {\n  margin: 3px 0;\n}\n\n.fjs-editor-container .fjs-children .fjs-element {\n  position: relative;\n  border: solid 2px transparent;\n  outline: none;\n}\n\n.fjs-editor-container .fjs-form > .fjs-element {\n  border: none;\n  outline: none;\n}\n\n.fjs-editor-container .fjs-form-field:not(.fjs-powered-by) {\n  margin: 1px 6px;\n}\n\n.fjs-editor-container .fjs-children .fjs-element.fjs-outlined {\n  border-color: var(--color-borders-group);\n}\n\n.fjs-editor-container .fjs-children .fjs-element.fjs-dashed-outlined {\n  border-color: var(--color-borders-group);\n  border-style: dashed;\n}\n\n.fjs-editor-container .fjs-children .fjs-element.fjs-editor-selected {\n  border-color: var(--color-children-selected-border) !important;\n  background-color: var(--color-children-selected-background);\n  border-style: solid;\n}\n\n.fjs-editor-container .fjs-children .fjs-element:hover.fjs-editor-hovered,\n.fjs-editor-container .fjs-children .fjs-element:focus {\n  border-color: var(--color-children-hover-border);\n  border-style: solid;\n}\n\n.fjs-editor-container .fjs-layout-column:first-child > .fjs-element[data-field-type=group],\n.fjs-editor-container .fjs-layout-column:first-child > .fjs-element[data-field-type=dynamiclist] {\n  margin-left: -6px;\n}\n\n.fjs-editor-container .fjs-layout-column:last-child > .fjs-element[data-field-type=group],\n.fjs-editor-container .fjs-layout-column:last-child > .fjs-element[data-field-type=dynamiclist] {\n  margin-right: -6px;\n}\n\n.fjs-editor-container .fjs-form-field-grouplike,\n.fjs-editor-container .fjs-form-field-grouplike .fjs-form-field-grouplike .fjs-form-field-grouplike {\n  margin: 1px 6px;\n  padding: 0px;\n}\n\n.fjs-editor-container .fjs-form-field-grouplike.fjs-outlined {\n  outline: none;\n}\n\n.fjs-editor-container .fjs-form-field-grouplike .cds--grid {\n  padding: 0 2rem;\n}\n\n.fjs-editor-container .fjs-form-field-grouplike > label {\n  margin-top: 6px;\n}\n\n.fjs-editor-container .fjs-input:disabled,\n.fjs-editor-container .fjs-textarea:disabled,\n.fjs-editor-container .fjs-taglist-input:disabled,\n.fjs-editor-container .fjs-button:disabled,\n.fjs-editor-container .fjs-select:disabled {\n  pointer-events: none;\n}\n\n.fjs-editor-container .fjs-readonly {\n  pointer-events: none;\n}\n\n.fjs-editor-container .fjs-drag-container,\n.fjs-editor-container .fjs-drop-container-vertical {\n  user-select: none;\n}\n\n.fjs-editor-container .fjs-empty-component {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 80px;\n  width: calc(100% - 4rem);\n  position: absolute;\n  container-type: size;\n}\n\n.fjs-editor-container .fjs-empty-component .fjs-empty-component-text {\n  color: var(--cds-text-disabled, var(--color-grey-225-10-55));\n}\n\n@container (width < 100px) {\n  .fjs-empty-component-text {\n    display: none;\n  }\n}\n.fjs-editor-container .fjs-empty-editor {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.fjs-cursor-grabbing .fjs-editor-container .fjs-empty-editor {\n  display: none;\n}\n\n.fjs-editor-container .fjs-empty-editor .fjs-empty-editor-card {\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n}\n\n.fjs-editor-container .fjs-drop-container-horizontal {\n  width: 100%;\n}\n\n.fjs-editor-container .fjs-layout-row {\n  padding: 4px 0px;\n}\n\n.fjs-editor-container .fjs-drag-row-move {\n  display: flex;\n  width: 100%;\n  padding: 3px 0px;\n  position: relative;\n}\n\n.fjs-editor-container .fjs-row-dragger {\n  z-index: 2;\n  position: absolute;\n  top: 25%;\n  height: 50%;\n  left: -33px;\n  width: 23px;\n  padding-right: 7px;\n  cursor: grab;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.fjs-editor-container .fjs-row-dragger svg {\n  visibility: hidden;\n}\n\n.fjs-editor-container .fjs-row-dragger:hover svg,\n.fjs-editor-container .fjs-drag-row-move:hover > .fjs-row-dragger svg {\n  visibility: visible;\n}\n\n.fjs-editor-container .fjs-drag-move {\n  padding: 0 3px;\n}\n\n.fjs-editor-container .fjs-field-resize-handle {\n  resize: horizontal;\n  position: absolute;\n  visibility: hidden;\n  width: 6px;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  height: 50px;\n  max-height: calc(100% - 2px);\n  border: 1px solid var(--color-resize-handle-border);\n  border-radius: 50px;\n  background: var(--color-white);\n  z-index: 3;\n}\n\n.fjs-editor-container .fjs-field-resize-handle-right {\n  right: -4px;\n  cursor: ew-resize;\n}\n\n.fjs-editor-container .fjs-field-resize-handle-left {\n  left: -4px;\n  cursor: ew-resize;\n}\n\n.fjs-editor-container .fjs-element-resizing-right .fjs-field-resize-handle-right,\n.fjs-editor-container .fjs-element-resizing-left .fjs-field-resize-handle-left,\n.fjs-editor-container .fjs-field-resize-handle:hover {\n  background: var(--color-resize-handle-background);\n}\n\n.fjs-editor-container .fjs-element-resizing-right .fjs-context-pad,\n.fjs-editor-container .fjs-element-resizing-left .fjs-context-pad {\n  display: none;\n}\n\n.fjs-editor-container .fjs-children .fjs-editor-selected > .fjs-field-resize-handle {\n  visibility: visible;\n}\n\n.fjs-resize-drag-preview {\n  width: 1px;\n  height: 1px;\n  position: absolute;\n  top: 0;\n}\n\n.fjs-editor-container .fjs-repeat-render-footer {\n  font-size: var(--font-size-label);\n  background: var(--cds-field, var(--color-background-disabled));\n  color: var(--color-text-light);\n  padding: 3px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0px 5px 3px 5px;\n}\n\n.fjs-editor-container .fjs-repeat-render-footer svg {\n  margin-right: 4px;\n}\n\n/* do not show resize handles on small screens */\n@media (max-width: 66rem) {\n  .fjs-editor-container .fjs-children .fjs-editor-selected .fjs-field-resize-handle {\n    display: none !important;\n  }\n}\n/**\n * Cursor styles\n */\n.fjs-cursor-grab {\n  cursor: -webkit-grab;\n  cursor: -moz-grab;\n  cursor: grab;\n}\n\n.fjs-cursor-grabbing {\n  cursor: -webkit-grabbing;\n  cursor: -moz-grabbing;\n  cursor: grabbing;\n}\n\n.fjs-cursor-crosshair {\n  cursor: crosshair;\n}\n\n.fjs-cursor-move {\n  cursor: move;\n}\n\n.fjs-cursor-not-allowed {\n  cursor: not-allowed;\n}\n\n/**\n * Context Pad\n */\n.fjs-editor-container .fjs-context-pad {\n  z-index: 2;\n  position: absolute;\n  top: 0;\n  right: 5px;\n}\n\n.fjs-editor-container .fjs-context-pad-item {\n  border: none;\n  background-color: var(--color-context-pad-item-background);\n  padding: 0;\n  width: 24px;\n  height: 24px;\n  color: var(--color-context-pad-item-fill);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.fjs-editor-container .fjs-context-pad-item:hover {\n  color: var(--color-context-pad-item-hover-fill);\n}\n\n.fjs-editor-container .fjs-context-pad-item:focus-visible {\n  outline: 2px solid var(--color-children-selected-border);\n  border-radius: 2px;\n}\n\n/**\n * Palette\n */\n.fjs-editor-container .fjs-palette-container {\n  height: 100%;\n}\n\n.fjs-palette-container {\n  width: var(--palette-width);\n  background-color: var(--color-palette-container-background);\n  border-right: solid 1px var(--color-palette-container-border);\n  font-family: var(--font-family);\n}\n\n.fjs-palette-container .fjs-palette {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.fjs-palette-container .fjs-palette-header {\n  font-size: 14px;\n  font-weight: bold;\n  color: var(--color-palette-header);\n  padding: 10px 15px;\n  border-bottom: solid 1px var(--color-palette-header-border);\n  background: var(--color-palette-header-background);\n  user-select: none;\n}\n\n.fjs-palette-container .fjs-palette-footer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.fjs-palette-container .fjs-palette-footer .fjs-palette-footer-fill {\n  padding: 10px;\n  width: 100%;\n}\n\n.fjs-palette-container .fjs-palette-search-container {\n  display: flex;\n  flex-direction: row;\n  padding: 4px;\n  margin: 12px;\n  color: var(--color-palette-search);\n  border: 1px solid var(--color-palette-search-border);\n  background-color: var(--color-palette-search-background);\n  border-radius: 2px;\n  font-size: 14px;\n}\n\n.fjs-palette-container .fjs-palette-search-container:focus-within {\n  outline: none;\n  background-color: var(--color-palette-search-focus-background);\n  border: 1px solid var(--color-palette-search-focus-border);\n}\n\n.fjs-palette-container .fjs-palette-search-icon {\n  margin-right: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-palette-search-icon);\n}\n\n.fjs-palette-container .fjs-palette-search {\n  background-color: inherit;\n  font-family: inherit;\n  margin: 0;\n  border: none;\n  padding: 0;\n  color: var(--color-palette-text);\n}\n\n.fjs-palette-container .fjs-palette-search:focus {\n  outline: none;\n}\n\n.fjs-palette-container .fjs-palette-search-clear {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: none;\n  margin-left: auto;\n  padding: 0;\n  background: transparent;\n  color: var(--color-palette-search-icon);\n}\n\n.fjs-palette-container .fjs-palette-search-clear svg {\n  margin: 0;\n}\n\n.fjs-palette-container .fjs-palette-search-clear:hover {\n  color: var(--color-palette-search-icon-hover);\n}\n\n.fjs-palette-container .fjs-palette-entries {\n  display: flex;\n  flex-direction: column;\n  overflow-x: hidden;\n  overflow-y: auto;\n  gap: 20px;\n  padding-bottom: 20px;\n}\n\n.fjs-palette-container .fjs-palette-group {\n  display: flex;\n  flex-direction: column;\n  width: 236px;\n  margin: auto;\n}\n\n.fjs-palette-container .fjs-palette-group-title {\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 4px;\n  color: var(--color-palette-group-title);\n  user-select: none;\n}\n\n.fjs-palette-container .fjs-palette-fields {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.fjs-palette-field {\n  height: 72px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  font-size: 11px;\n  align-items: center;\n  border: none;\n  font-family: inherit;\n  user-select: none;\n  color: var(--color-palette-field);\n  background-color: var(--color-palette-field-background);\n  outline: solid 1px var(--color-palette-field-border);\n  outline-offset: 0px;\n  transition: all ease-in-out 0.05s;\n}\n\n.fjs-palette-container .fjs-palette-field {\n  width: 72px;\n}\n\n.fjs-palette-container .fjs-palette-field:focus {\n  outline: solid 1px var(--color-palette-field-focus);\n}\n\n.fjs-palette-field .fjs-palette-field-icon,\n.fjs-palette-field .fjs-field-icon-image {\n  margin: 0 auto;\n}\n\n.fjs-palette-field .fjs-palette-field-text {\n  text-align: center;\n  width: inherit;\n}\n\n.fjs-palette-container .fjs-palette-field:hover {\n  outline: solid 1px var(--color-palette-field-hover-border);\n  cursor: var(--cursor-palette-field);\n}\n\n.fjs-palette-container .fjs-palette-no-entries {\n  padding: 5px 15px;\n  font-size: 14px;\n  color: var(--color-palette-text);\n}\n\n/**\n * JSON Editors\n */\n.fjs-json-editor .cm-editor {\n  font-size: var(--font-size-label);\n  line-height: var(--line-height-label);\n  letter-spacing: var(--letter-spacing-label);\n}\n\n.fjs-json-editor .cm-placeholder {\n  color: var(--cds-text-placeholder, var(--color-grey-225-10-35));\n}\n\n.fjs-json-editor .cm-placeholder > :first-child {\n  margin-top: 0;\n}\n\n.fjs-json-editor.fjs-cm-no-lint .cm-lint-marker,\n.fjs-json-editor.fjs-cm-no-lint .cm-lintPoint-error {\n  display: none;\n}\n\n.fjs-json-editor.fjs-cm-no-lint .cm-activeLine,\n.fjs-json-editor.fjs-cm-no-lint .cm-activeLineGutter {\n  background: none;\n}\n\n/**\n * Properties Panel\n */\n.fjs-editor-container .fjs-properties-container {\n  height: 100%;\n}\n\n.fjs-properties-container {\n  background-color: var(--color-properties-container-background);\n  width: var(--properties-panel-width);\n  border-left: solid 1px var(--color-properties-container-border);\n  color: var(--color-text);\n}\n\n.fjs-properties-container .fjs-properties-panel {\n  height: 100%;\n}\n\n.fjs-properties-container .fjs-properties-panel * {\n  box-sizing: border-box;\n}\n\n.fjs-properties-container .fjs-properties-panel .bio-properties-panel-header-icon svg {\n  transform: scale(1.3);\n}\n\n.fjs-properties-container .fjs-properties-panel .fjs-properties-panel-detached-description {\n  margin: 0px 12px 6px;\n}\n\n.fjs-properties-container .fjs-properties-panel .cm-editor {\n  max-height: 400px;\n}\n\n/**\n * Editor Form Fields\n */\n.fjs-editor-container .fjs-form-field-placeholder {\n  color: var(--color-text-light);\n  font-style: italic;\n}\n\n.fjs-editor-container .fjs-form-field-placeholder svg {\n  width: 32px;\n  height: 32px;\n  vertical-align: middle;\n  margin-top: -2px;\n  margin-right: 2px;\n}\n\n.fjs-editor-container .fjs-form-field-spacer {\n  min-height: 30px;\n  background: repeating-linear-gradient(45deg, #ffffff, #ffffff 10px, #f5f5f5 10px, #f5f5f5 20px);\n}\n\n.fjs-editor-container .fjs-form-field-html,\n.fjs-editor-container .fjs-form-field-text {\n  min-height: 30px;\n}\n\n.fjs-editor-container .fjs-form-field-separator hr {\n  margin: 10px 2px;\n}\n\n/**\n * Custom Dragula Styles\n */\n.gu-transit {\n  background: var(--color-dragula-background) !important;\n  border: dashed 2px var(--color-dragula-border) !important;\n  border-radius: 3px !important;\n  filter: none !important;\n  height: 70px !important;\n  opacity: 1 !important;\n  /* mitigate for additional border in row */\n  flex-grow: 0.98 !important;\n  margin: 0 !important;\n}\n\n/* row drop preview */\n.fjs-children > .gu-transit {\n  height: 28px !important;\n  width: 100% !important;\n  flex: unset !important;\n}\n\n/* error drop preview */\n.fjs-error-drop > .gu-transit {\n  height: 100% !important;\n  background: var(--color-dragula-error-background) !important;\n  border: none !important;\n  width: 6px !important;\n  flex: none !important;\n  padding: 0 !important;\n  border-radius: 5px !important;\n}\n\n.fjs-error-drop.cds--row {\n  flex-wrap: nowrap !important;\n}\n\n.gu-transit * {\n  display: none !important;\n}\n\n.gu-mirror {\n  background-color: var(--color-dragula-mirror-background) !important;\n  border: solid 1px var(--color-dragula-mirror-border) !important;\n  border-radius: 5px !important;\n  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15) !important;\n  display: flex !important;\n  filter: none !important;\n  flex-direction: row !important;\n  justify-content: center !important;\n  align-items: center !important;\n  opacity: 0.5 !important;\n  padding: 0 !important;\n  pointer-events: none !important;\n  height: 54px !important;\n}\n\n.fjs-field-preview {\n  margin: 5px 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  font-size: 11px;\n  user-select: none;\n  color: var(--color-text);\n  background: var(--color-white);\n}\n\n.fjs-field-preview .fjs-field-preview-icon {\n  margin: 0 auto;\n}\n\n.fjs-field-preview .fjs-field-preview-text {\n  text-align: center;\n}\n\n.gu-mirror.fjs-field-preview-container {\n  transform: rotate(-15deg);\n  font-family: var(--font-family);\n  width: 68px !important;\n  height: 68px !important;\n}\n\n.gu-mirror.fjs-drag-row-move {\n  padding: 4px 12px !important;\n  height: fit-content !important;\n  opacity: 0.8 !important;\n  max-height: 120px !important;\n  overflow: hidden !important;\n  align-items: start !important;\n}\n\n.gu-mirror.fjs-drag-row-move .cds--row {\n  flex-wrap: nowrap !important;\n}\n\n.gu-mirror {\n  position: fixed !important;\n  margin: 0 !important;\n  z-index: 9999 !important;\n  opacity: 0.8;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=80)\";\n  filter: alpha(opacity=80);\n}\n\n.gu-hide {\n  display: none !important;\n}\n\n.gu-unselectable {\n  -webkit-user-select: none !important;\n  -moz-user-select: none !important;\n  -ms-user-select: none !important;\n  user-select: none !important;\n}\n\n.gu-transit {\n  opacity: 0.2;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=20)\";\n  filter: alpha(opacity=20);\n}\n\n/**\n * Theming\n */\n.bio-properties-panel,\n.djs-parent {\n  --color-grey-225-10-15: hsl(225, 10%, 15%);\n  --color-grey-225-10-35: hsl(225, 10%, 35%);\n  --color-grey-225-10-55: hsl(225, 10%, 55%);\n  --color-grey-225-10-75: hsl(225, 10%, 75%);\n  --color-grey-225-10-80: hsl(225, 10%, 80%);\n  --color-grey-225-10-85: hsl(225, 10%, 85%);\n  --color-grey-225-10-90: hsl(225, 10%, 90%);\n  --color-grey-225-10-95: hsl(225, 10%, 95%);\n  --color-grey-225-10-97: hsl(225, 10%, 97%);\n  --color-grey-0-0-22: hsl(0, 0%, 22%);\n  --color-blue-205-100-35: hsl(205, 100%, 35%);\n  --color-blue-205-100-40: hsl(205, 100%, 40%);\n  --color-green-150-86-44: hsl(150, 86%, 44%);\n  --color-blue-205-100-45: hsl(205, 100%, 45%);\n  --color-blue-205-100-50: hsl(205, 100%, 50%);\n  --color-blue-219-99-53: hsl(219, 99%, 53%);\n  --color-blue-218-100-74: hsl(218, 100%, 74%);\n  --color-blue-205-100-85: hsl(205, 100%, 85%);\n  --color-blue-205-100-95: hsl(205, 100%, 95%);\n  --color-red-360-100-40: hsl(360, 100%, 40%);\n  --color-red-360-100-45: hsl(360, 100%, 45%);\n  --color-red-360-100-92: hsl(360, 100%, 92%);\n  --color-red-360-100-97: hsl(360, 100%, 97%);\n  --color-white: white;\n  --color-black: black;\n  --color-transparent: transparent;\n}\n\n.bio-properties-panel {\n  --text-base-color: var(--color-grey-225-10-15);\n  --text-error-color: var(--color-red-360-100-45);\n  --link-color: var(--color-blue-205-100-50);\n  --description-color: var(--color-grey-225-10-35);\n  --description-code-background-color: var(--color-grey-225-10-97);\n  --description-code-border-color: var(--color-grey-225-10-85);\n  --description-list-item-color: var(--color-grey-225-10-35);\n  --placeholder-color: var(--color-grey-225-10-35);\n  --placeholder-background-color: var(--color-grey-225-10-95);\n  --header-background-color: var(--color-grey-225-10-95);\n  --header-icon-fill-color: var(--color-grey-225-10-15);\n  --header-bottom-border-color: var(--color-grey-225-10-75);\n  --group-background-color: var(--color-white);\n  --group-bottom-border-color: var(--color-grey-225-10-75);\n  --sticky-group-background-color: var(--color-grey-225-10-95);\n  --sticky-group-bottom-border-color: var(--color-grey-225-10-75);\n  --add-entry-fill-color: var(--color-grey-225-10-35);\n  --add-entry-hover-fill-color: var(--color-white);\n  --add-entry-hover-background-color: var(--color-blue-205-100-50);\n  --add-entry-label-color: var(--color-white);\n  --remove-entry-fill-color: var(--color-red-360-100-45);\n  --remove-entry-hover-background-color: var(--color-red-360-100-92);\n  --arrow-fill-color: var(--color-grey-225-10-35);\n  --arrow-hover-background-color: var(--color-grey-225-10-95);\n  --dot-color: var(--color-grey-225-10-35);\n  --dot-color-error: var(--color-red-360-100-45);\n  --list-badge-color: var(--color-white);\n  --list-badge-background-color: var(--color-grey-225-10-35);\n  --input-background-color: var(--color-grey-225-10-97);\n  --input-border-color: var(--color-grey-225-10-75);\n  --input-focus-background-color: var(--color-blue-205-100-95);\n  --input-focus-border-color: var(--color-blue-205-100-50);\n  --focus-outline-color: var(--color-blue-205-100-40);\n  --input-error-background-color: var(--color-red-360-100-97);\n  --input-error-border-color: var(--color-red-360-100-45);\n  --input-error-focus-border-color: var(--color-red-360-100-45);\n  --input-disabled-color: var(--color-grey-225-10-55);\n  --input-disabled-background-color: var(--color-grey-225-10-97);\n  --input-disabled-border-color: var(--color-grey-225-10-90);\n  --toggle-switch-on-background-color: var(--color-blue-205-100-50);\n  --toggle-switch-off-background-color: var(--color-grey-225-10-75);\n  --toggle-switch-switcher-background-color: var(--color-white);\n  --side-line-background-color: var(--color-grey-225-10-35);\n  --side-line-extension-background-color: var(--color-grey-225-10-35);\n  --list-entry-dot-background-color: var(--color-grey-225-10-35);\n  --list-entry-header-button-fill-color: var(--color-grey-225-10-35);\n  --list-entry-add-entry-empty-background-color: var(--color-blue-205-100-50);\n  --list-entry-add-entry-empty-hover-background-color: var(--color-blue-205-100-45);\n  --list-entry-add-entry-label-color: var(--color-white);\n  --list-entry-add-entry-background-color: var(--color-blue-205-100-50);\n  --list-entry-add-entry-fill-color: var(--color-white);\n  --dropdown-item-background-color: var(--color-white);\n  --dropdown-item-hover-background-color: var(--color-grey-225-10-95);\n  --dropdown-separator-background-color: var(--color-grey-225-10-75);\n  --feel-background-color: transparent;\n  --feel-active-color: var(--color-blue-205-100-45);\n  --feel-inactive-color: var(--color-grey-225-10-35);\n  --feel-hover-color: var(--color-grey-225-10-15);\n  --feel-hover-background-color: var(--color-grey-225-10-97);\n  --feel-active-background-color: transparent;\n  --feel-required-color: var(--color-grey-225-10-55);\n  --feel-open-popup-color: hsla(0, 0%, 32%, 1);\n  --feel-open-popup-background-color: var(--color-white);\n  --feel-open-popup-hover-color: hsla(219, 99%, 53%, 1);\n  --feel-indicator-background-color: var(--color-grey-225-10-90);\n  --feelers-select-color: var(--color-blue-205-100-85);\n  --text-size-base: 14px;\n  --text-size-small: 13px;\n  --text-size-smallest: 12px;\n  --text-line-height: 21px;\n  --line-height-condensed: 17px;\n  --font-family: sans-serif;\n  --font-family-monospace: monospace;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  position: relative;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n\n.bio-properties-panel {\n  color: var(--text-base-color);\n}\n\n.bio-properties-panel * {\n  font-size: var(--text-size-base);\n  line-height: var(--text-line-height);\n  font-weight: 400;\n  box-sizing: border-box;\n}\n\n.bio-properties-panel {\n  font-family: var(--font-family);\n}\n\n/**\n * Placeholder (empty, multi select, ...)\n */\n.bio-properties-panel-placeholder {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: var(--placeholder-background-color);\n}\n\n.bio-properties-panel-placeholder-text {\n  color: var(--placeholder-color);\n  font-size: var(--text-size-base);\n  text-align: center;\n  margin: 12px 48px;\n}\n\n/**\n * Header\n */\n.bio-properties-panel-header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  font-size: var(--text-size-base);\n  padding: 16px 10px;\n  background-color: var(--header-background-color);\n  border-bottom: 1px solid var(--header-bottom-border-color);\n  width: 100%;\n  z-index: 10;\n  max-height: 64px;\n  overflow: hidden;\n}\n\n.bio-properties-panel-header-icon {\n  fill: var(--header-icon-fill-color);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n}\n\n.bio-properties-panel-header-labels {\n  overflow: hidden;\n  margin-left: 12px;\n  user-select: none;\n}\n\n.bio-properties-panel-header-type {\n  font-size: var(--text-size-smallest);\n  font-weight: 600;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  text-transform: uppercase;\n}\n\n.bio-properties-panel-header-label {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  margin-top: -6px;\n}\n\n.bio-properties-panel-header-actions {\n  margin-left: auto;\n  margin-top: auto;\n}\n\n/**\n * Scroll container\n */\n.bio-properties-panel-scroll-container {\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex: 1;\n}\n\n/**\n * Groups\n */\n.bio-properties-panel-group {\n  background-color: var(--group-background-color);\n  border-bottom: 1px solid var(--group-bottom-border-color);\n  position: relative;\n}\n\n.bio-properties-panel-group-header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  font-size: var(--text-size-base);\n  height: 32px;\n  user-select: none;\n  justify-content: space-between;\n  margin-bottom: -1px; /* avoid double borders */\n  position: relative; /* browsers not supporting sticky */\n  position: -webkit-sticky; /* for safari */\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.bio-properties-panel-group-header .bio-properties-panel-group-header-title {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin: 1px 12px 0;\n}\n\n.bio-properties-panel-group-header.open .bio-properties-panel-group-header-title {\n  font-weight: 500;\n}\n\n.bio-properties-panel-group-header.sticky {\n  background-color: var(--sticky-group-background-color);\n  border-bottom: 1px solid var(--sticky-group-bottom-border-color);\n}\n\n.bio-properties-panel-group-header-buttons {\n  display: flex;\n}\n\n.bio-properties-panel-group-header-buttons .bio-properties-panel-group-header-button {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  align-self: center;\n  height: 22px;\n  line-height: 22px;\n  min-width: 22px;\n  margin: 5px;\n  padding: 0 3px;\n  border: none;\n  background: none;\n}\n\n.bio-properties-panel-group-header-button:focus {\n  outline-offset: 2px;\n  outline-color: var(--focus-outline-color);\n}\n\n.bio-properties-panel-group-header-buttons .bio-properties-panel-group-header-buttons:last-child {\n  margin-right: 0;\n}\n\n.bio-properties-panel-add-entry {\n  fill: var(--add-entry-fill-color);\n  border-radius: 11px;\n}\n\n.bio-properties-panel-group-header.empty .bio-properties-panel-add-entry {\n  margin-right: 69px;\n}\n\n.bio-properties-panel-group-header.empty .bio-properties-panel-add-entry:hover {\n  margin-right: 19px;\n}\n\n.bio-properties-panel-group-header.empty .bio-properties-panel-add-entry-label {\n  display: none;\n  color: var(--add-entry-label-color);\n  padding: 0 6px 0 2px;\n}\n\n.bio-properties-panel-group-header-button.bio-properties-panel-add-entry:hover {\n  background-color: var(--add-entry-hover-background-color);\n  fill: var(--add-entry-hover-fill-color);\n}\n\n.bio-properties-panel-group-header-button.bio-properties-panel-add-entry:hover .bio-properties-panel-add-entry-label {\n  display: block;\n}\n\n.bio-properties-panel-group-entries {\n  display: none;\n}\n\n.bio-properties-panel-group-entries.open {\n  display: block;\n}\n\n.bio-properties-panel-arrow {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  fill: var(--arrow-fill-color);\n  min-width: 22px;\n  border-radius: 11px;\n  border: none;\n  background: none;\n}\n\n.bio-properties-panel-arrow:hover {\n  background-color: var(--arrow-hover-background-color);\n}\n\n.bio-properties-panel-arrow-down {\n  transform: rotate(90deg);\n}\n\n.bio-properties-panel-dot {\n  align-self: center;\n  height: 8px;\n  min-width: 8px;\n  border-radius: 50%;\n  margin: 12px;\n  background-color: var(--dot-color);\n}\n\n.bio-properties-panel-dot--error {\n  --dot-color: var(--dot-color-error);\n}\n\n/**\n * Lists\n */\n.bio-properties-panel-list {\n  display: none;\n}\n\n.bio-properties-panel-list.open {\n  display: block;\n  margin-bottom: 6px;\n  padding-bottom: 2px;\n}\n\n.bio-properties-panel-list-badge {\n  height: 22px;\n  min-width: 22px;\n  color: var(--list-badge-color);\n  border-radius: 11px;\n  font-size: var(--text-size-small);\n  line-height: 22px;\n  text-align: center;\n  user-select: none;\n  padding: 0 5px;\n  margin: 5px;\n  background-color: var(--list-badge-background-color);\n}\n\n.bio-properties-panel-list-badge--error {\n  --list-badge-background-color: var(--dot-color-error);\n}\n\n/**\n * Basic entries\n */\n.bio-properties-panel-entry {\n  margin: 2px 32px 6px 12px;\n}\n\n.bio-properties-panel-entry:last-child {\n  padding-bottom: 10px;\n}\n\n.bio-properties-panel-label {\n  display: block;\n  font-size: var(--text-size-small);\n  margin: 2px 0 1px;\n}\n\n.bio-properties-panel-description,\n.bio-properties-panel-description p,\n.bio-properties-panel-description span,\n.bio-properties-panel-description div {\n  color: var(--description-color);\n  display: block;\n  margin: 2px 0 4px;\n  line-height: var(--line-height-condensed);\n  font-weight: 400;\n  font-size: var(--text-size-small);\n}\n\n.bio-properties-panel-description code {\n  color: var(--description-color);\n  font-family: var(--font-family);\n  font-size: var(--text-size-small);\n  line-height: var(--line-height-condensed);\n  padding: 0 2px;\n  background-color: var(--description-code-background-color);\n  border: 1px solid var(--description-code-border-color);\n  border-radius: 3px;\n}\n\n.bio-properties-panel-description pre code {\n  width: 100%;\n  display: block;\n  overflow-x: auto;\n  padding: 4px 6px;\n  font-family: var(--font-family-monospace);\n}\n\n.bio-properties-panel-description ul {\n  padding: 0;\n  margin: 0 0 0 12px;\n  list-style-type: disc;\n}\n\n.bio-properties-panel-description li {\n  color: var(--description-list-item-color);\n  margin: 0 0 0 12px;\n}\n\n.bio-properties-panel-description a {\n  color: var(--link-color);\n  font-size: var(--text-size-small);\n  text-decoration: underline;\n}\n\n.bio-properties-panel-feelers-editor.bio-properties-panel-input {\n  padding: 0;\n}\n\n.bio-properties-panel-feelers-input .cm-editor {\n  min-height: 32px;\n  max-height: 215px;\n  background-color: transparent;\n}\n\n.bio-properties-panel-feelers-editor .cm-editor.cm-focused,\n.bio-properties-panel-feelers-input .cm-editor.cm-focused {\n  outline: none;\n}\n\n.bio-properties-panel-input {\n  padding: 3px 6px 2px;\n  border: 1px solid var(--input-border-color);\n  border-radius: 2px;\n  background-color: var(--input-background-color);\n  font-size: var(--text-size-base);\n  font-family: inherit;\n}\n\n.bio-properties-panel-input[type=number],\nselect.bio-properties-panel-input,\ntextarea.bio-properties-panel-input,\n.bio-properties-panel-input[type=text] {\n  display: block;\n  width: 100%;\n}\n\ntextarea.bio-properties-panel-input {\n  min-height: 28px;\n}\n\n.bio-properties-panel-input:focus,\n.bio-properties-panel-input:focus-within {\n  outline: none;\n  background-color: var(--input-focus-background-color);\n  border: 1px solid var(--input-focus-border-color);\n}\n\n.bio-properties-panel-textfield:focus-within,\n.bio-properties-panel-feel-entry:focus-within {\n  --input-background-color: var(--input-focus-background-color);\n  --input-border-color: var(--input-focus-border-color);\n}\n\n.bio-properties-panel-input:disabled {\n  border-color: var(--input-disabled-border-color);\n  background-color: var(--input-disabled-background-color);\n  color: var(--input-disabled-color);\n}\n\nselect.bio-properties-panel-input {\n  padding: 4px 6px;\n}\n\n.bio-properties-panel-input-monospace {\n  font-family: var(--font-family-monospace);\n}\n\n.bio-properties-panel-input[type=checkbox], .bio-properties-panel-input[type=radio] {\n  margin: 0;\n  vertical-align: middle;\n}\n\n.bio-properties-panel-input[type=checkbox]:focus {\n  outline: auto;\n  outline-color: var(--focus-outline-color);\n  outline-offset: 2px;\n}\n\n.bio-properties-panel-checkbox > .bio-properties-panel-label {\n  display: inline-block;\n  font-size: var(--text-size-base);\n  margin-left: 6px;\n  margin-top: auto;\n  vertical-align: middle;\n}\n\n.bio-properties-panel-checkbox-entry + .bio-properties-panel-checkbox-entry {\n  margin-top: -8px;\n}\n\n.bio-properties-panel-checkbox-entry > .bio-properties-panel-description {\n  margin-left: 18px;\n}\n\ntextarea.bio-properties-panel-input {\n  resize: vertical;\n}\n\n.bio-properties-panel-entry.has-error .bio-properties-panel-input,\n.bio-properties-panel-entry.has-error .bio-properties-panel-feel-editor__open-popup-placeholder {\n  border-color: var(--input-error-border-color);\n  background-color: var(--input-error-background-color);\n}\n\n.bio-properties-panel-entry.has-error .bio-properties-panel-feel-indicator {\n  border-color: var(--input-error-border-color);\n}\n\n.bio-properties-panel-entry.has-error .bio-properties-panel-input:focus,\n.bio-properties-panel-entry.has-error .bio-properties-panel-feel-indicator:focus {\n  border-color: var(--input-error-focus-border-color);\n}\n\n.bio-properties-panel-entry .bio-properties-panel-error {\n  color: var(--text-error-color);\n  margin: 4px 0;\n  font-size: var(--text-size-small);\n}\n\n.bio-properties-panel-simple {\n  width: 100%;\n  margin-right: 8px;\n}\n\n.bio-properties-panel-simple + .bio-properties-panel-remove-entry {\n  margin: auto;\n}\n\n/**\n * Toggle Switch\n */\n.bio-properties-panel-toggle-switch-entry + .bio-properties-panel-toggle-switch-entry {\n  margin-top: -8px;\n}\n\n.bio-properties-panel-toggle-switch-entry > .bio-properties-panel-description {\n  margin-left: 38px;\n}\n\n.bio-properties-panel-toggle-switch .bio-properties-panel-field-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.bio-properties-panel-toggle-switch.inline {\n  display: flex;\n  flex-direction: row;\n}\n\n.bio-properties-panel-toggle-switch.inline .bio-properties-panel-field-wrapper {\n  margin-left: auto;\n}\n\n.bio-properties-panel-toggle-switch > .bio-properties-panel-label {\n  font-size: var(--text-size-base);\n}\n\n.bio-properties-panel-toggle-switch.inline > .bio-properties-panel-label {\n  font-size: var(--text-size-small);\n}\n\n.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__label {\n  margin: 0;\n  margin-left: 6px;\n  font-size: var(--text-size-base);\n}\n\n.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher {\n  position: relative;\n  width: 32px;\n  height: 16px;\n}\n\n.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher:focus-within {\n  outline: 2px solid var(--input-focus-border-color);\n  outline-offset: 1px;\n}\n\n.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher input[type=checkbox] {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher .bio-properties-panel-toggle-switch__slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--toggle-switch-off-background-color);\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n  border-radius: 34px;\n}\n\n.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher .bio-properties-panel-toggle-switch__slider:before {\n  position: absolute;\n  content: \"\";\n  height: 12px;\n  width: 12px;\n  left: 2px;\n  bottom: 2px;\n  background-color: var(--toggle-switch-switcher-background-color);\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n  border-radius: 50%;\n}\n\n.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher input[type=checkbox]:checked + .bio-properties-panel-toggle-switch__slider {\n  background-color: var(--toggle-switch-on-background-color);\n  box-shadow: 0 0 1px;\n}\n\n.bio-properties-panel-toggle-switch .bio-properties-panel-toggle-switch__switcher input[type=checkbox]:checked + .bio-properties-panel-toggle-switch__slider:before {\n  -webkit-transform: translateX(16px);\n  -ms-transform: translateX(16px);\n  transform: translateX(16px);\n}\n\n/**\n * Collapsible entries\n */\n.bio-properties-panel-collapsible-entry-entries {\n  position: relative;\n  display: none;\n}\n\n.bio-properties-panel-collapsible-entry-entries .bio-properties-panel-entry:last-child {\n  padding-bottom: 0;\n}\n\n.bio-properties-panel-collapsible-entry-entries.open {\n  display: block;\n}\n\n.bio-properties-panel-collapsible-entry-entries {\n  padding-left: 20px;\n  margin-bottom: 10px;\n  position: relative;\n  display: none;\n}\n\n.bio-properties-panel-collapsible-entry-header {\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  overflow: hidden;\n}\n\n.bio-properties-panel-collapsible-entry-header .bio-properties-panel-collapsible-entry-header-title {\n  padding: 2px 24px 2px 32px;\n  font-size: var(--text-size-base);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  user-select: none;\n}\n\n.bio-properties-panel-collapsible-entry-arrow {\n  position: absolute;\n  top: 2px;\n  left: 6px;\n  padding: 0 3px;\n  height: 22px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  align-self: center;\n}\n\n.bio-properties-panel-remove-entry {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 5px;\n  padding: 0;\n  width: 22px;\n  height: 22px;\n  fill: var(--remove-entry-fill-color);\n  border-radius: 50%;\n  border: none;\n  background: none;\n  visibility: hidden;\n}\n\n.bio-properties-panel-remove-entry:hover {\n  background-color: var(--remove-entry-hover-background-color);\n}\n\n.bio-properties-panel-list-entry-item:hover .bio-properties-panel-remove-list-entry,\n.bio-properties-panel-collapsible-entry:hover > .bio-properties-panel-collapsible-entry-header .bio-properties-panel-remove-entry,\n.bio-properties-panel-collapsible-entry:focus-within > .bio-properties-panel-collapsible-entry-header .bio-properties-panel-remove-entry {\n  visibility: visible;\n}\n\n/* Side line */\n.bio-properties-panel-collapsible-entry-entries::before {\n  content: \"\";\n  position: absolute;\n  left: 16px;\n  width: 2px;\n  top: -6px;\n  bottom: 12px;\n  background-color: var(--side-line-background-color);\n  border-radius: 1px;\n}\n\n/* Side line extension for non-list entry or open list entry positioned as the last one. */\n.bio-properties-panel-collapsible-entry-entries .bio-properties-panel-entry:not(.bio-properties-panel-list-entry):last-child,\n.bio-properties-panel-list-entry.open:last-child {\n  position: relative;\n}\n\n.bio-properties-panel-collapsible-entry-entries .bio-properties-panel-entry:not(.bio-properties-panel-list-entry):last-child::after,\n.bio-properties-panel-list-entry.open:last-child::after {\n  content: \"\";\n  position: absolute;\n  left: -16px;\n  width: 2px;\n  top: 0;\n  bottom: -4px;\n  background-color: var(--side-line-extension-background-color);\n  border-radius: 1px;\n}\n\n.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry-entries .bio-properties-panel-entry:last-child::after {\n  left: -18px;\n}\n\n/*\n * List entry\n */\n.bio-properties-panel-list-entry {\n  position: relative;\n  margin-right: 5px;\n  margin-bottom: 0;\n}\n\n.bio-properties-panel-list-entry .bio-properties-panel-entry {\n  margin-right: 0;\n}\n\n.bio-properties-panel-list-entry-header {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  justify-content: space-between;\n  height: 32px;\n}\n\n/* Nested list dot */\n.bio-properties-panel-list-entry::before {\n  content: \"\";\n  width: 8px;\n  height: 8px;\n  position: absolute;\n  left: -19px;\n  top: 13px;\n  border-radius: 50%;\n  background-color: var(--list-entry-dot-background-color);\n}\n\n.bio-properties-panel-list-entry-header-title {\n  display: block;\n  margin: auto 0;\n  padding: 2px 0;\n  font-size: var(--text-size-base);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.bio-properties-panel-list-entry-header-title.open {\n  font-weight: 500;\n}\n\n.bio-properties-panel-list-entry-header-buttons {\n  display: flex;\n  align-items: center;\n}\n\n.bio-properties-panel-list-entry-header-buttons > button {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  align-self: center;\n  height: 22px;\n  line-height: 22px;\n  min-width: 22px;\n  margin: 5px;\n  padding: 0 3px;\n  border: none;\n  background: none;\n  fill: var(--list-entry-header-button-fill-color);\n}\n\n.bio-properties-panel-list-entry-header-buttons > :last-child {\n  margin-right: 0;\n}\n\n.bio-properties-panel-list-entry-items {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.bio-properties-panel-list-entry-items:not(.open) {\n  display: none;\n}\n\n.bio-properties-panel-list-entry-item {\n  display: flex;\n  justify-content: space-between;\n}\n\n.bio-properties-panel-list-entry-item .bio-properties-panel-remove-entry {\n  margin-right: 1px;\n}\n\n.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry {\n  width: 100%;\n  margin-right: 4px;\n}\n\n.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry-header {\n  margin-left: -8px;\n}\n\n.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry-arrow {\n  left: 2px;\n}\n\n.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry-header-title {\n  padding-left: 30px;\n}\n\n.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry-entries {\n  padding-left: 10px;\n}\n\n.bio-properties-panel-list-entry-item .bio-properties-panel-collapsible-entry-entries::before {\n  left: 4px;\n}\n\n.bio-properties-panel-list-entry.empty .bio-properties-panel-add-entry {\n  margin-right: 16px;\n  padding-left: 6px;\n}\n\n.bio-properties-panel-list-entry.empty .bio-properties-panel-add-entry-label {\n  color: var(--list-entry-add-entry-label-color);\n  padding: 4px 6px 3px 2px;\n}\n\n.bio-properties-panel-list-entry-header-buttons .bio-properties-panel-add-entry:hover {\n  background-color: var(--list-entry-add-entry-background-color);\n  fill: var(--list-entry-add-entry-fill-color);\n}\n\n.bio-properties-panel-list-entry-item .bio-properties-panel-simple .bio-properties-panel-input {\n  border-radius: 0;\n  margin-bottom: -2px;\n}\n\n.bio-properties-panel-list-entry-item:first-child .bio-properties-panel-simple .bio-properties-panel-input {\n  border-top-left-radius: 2px;\n  border-top-right-radius: 2px;\n}\n\n.bio-properties-panel-list-entry-item:last-child .bio-properties-panel-simple .bio-properties-panel-input {\n  border-bottom-left-radius: 2px;\n  border-bottom-right-radius: 2px;\n}\n\n.bio-properties-panel-dropdown-button {\n  position: relative;\n  --dropdown-button-margin: 5px;\n}\n\n.bio-properties-panel-dropdown-button:not(.open) .bio-properties-panel-dropdown-button__menu {\n  display: none;\n}\n\n.bio-properties-panel-dropdown-button__menu {\n  min-width: calc(100% - var(--dropdown-button-margin) * 2);\n  max-width: 240px;\n  position: absolute;\n  top: calc(100% - var(--dropdown-button-margin));\n  right: var(--dropdown-button-margin);\n  z-index: 101;\n  background-color: var(--dropdown-item-background-color);\n  padding: 8px 0;\n  box-shadow: 0 1px 4px 0 var(--color-grey-225-10-85), 0 2px 16px 0 var(--color-grey-225-10-75);\n}\n\n.bio-properties-panel-dropdown-button__menu-item {\n  display: block;\n  width: 100%;\n  padding: 4px 12px;\n  font-size: var(--text-size-small);\n  appearance: revert;\n  border: unset;\n  background: unset;\n  text-align: unset;\n}\n\n.bio-properties-panel-dropdown-button__menu-item--separator {\n  width: 100%;\n  height: 1px;\n  padding: 0;\n  margin: 8px 0;\n  background-color: var(--dropdown-separator-background-color);\n}\n\n.bio-properties-panel-dropdown-button__menu-item--actionable {\n  font-size: var(--text-size-base);\n}\n\n.bio-properties-panel-dropdown-button__menu-item--actionable:hover {\n  background-color: var(--dropdown-item-hover-background-color);\n}\n\n.bio-properties-panel-feel-input {\n  position: relative;\n}\n\n.bio-properties-panel-feel-input input {\n  padding-right: 2em;\n}\n\n.bio-properties-panel-feel-entry .bio-properties-panel-label {\n  display: flex;\n}\n\n.bio-properties-panel-feel-icon {\n  display: inline-flex;\n  height: 18px;\n  width: 22px;\n  vertical-align: text-bottom;\n  padding: 0;\n  margin: 0 3px;\n  align-items: center;\n  align-self: center;\n  justify-content: center;\n  border: none;\n  background: none;\n  border-radius: 3px;\n}\n\n.bio-properties-panel-feel-icon.optional {\n  cursor: pointer;\n  background: var(--feel-background-color);\n}\n\n.bio-properties-panel-feel-icon svg * {\n  fill: var(--feel-inactive-color);\n}\n\n.bio-properties-panel-feel-icon:hover {\n  background: var(--feel-hover-background-color);\n}\n\n.bio-properties-panel-feel-icon:hover svg * {\n  fill: var(--feel-hover-color);\n}\n\n.bio-properties-panel-feel-icon.active {\n  background: var(--feel-active-background-color);\n}\n\n.bio-properties-panel-feel-icon.active:hover {\n  background: var(--feel-hover-background-color);\n}\n\n.bio-properties-panel-feel-icon.required.active {\n  background: none;\n}\n\n.bio-properties-panel-feel-icon.active svg * {\n  fill: var(--feel-active-color);\n}\n\n.bio-properties-panel-feel-icon.required.active svg * {\n  fill: var(--feel-required-color);\n}\n\n.bio-properties-panel-feel-editor-container {\n  position: relative;\n}\n\n.bio-properties-panel-feel-editor-container.active {\n  font-family: var(--font-family-monospace);\n}\n\n.bio-properties-panel-feel-container {\n  position: relative;\n}\n\n.bio-properties-panel-feel-container .bio-properties-panel-feel-editor-container > div {\n  position: static;\n  padding-left: 2.4em !important;\n  min-height: 28px;\n}\n\n.bio-properties-panel-feel-indicator {\n  position: absolute;\n  border: 1px solid var(--input-border-color);\n  background-color: var(--feel-indicator-background-color);\n  border-right: 0px;\n  border-radius: 2px 0 0 2px;\n  z-index: 1;\n  height: 100%;\n  width: 2em;\n  text-align: center;\n  padding: 2px 6px;\n}\n\n.bio-properties-panel-feel-editor-container .cm-scroller {\n  overflow: hidden !important;\n}\n\n.bio-properties-panel-feelers-editor .cm-editor {\n  background-color: transparent;\n}\n\n/* @Note(pinussilvestrus): mitigate low contrast - https://github.com/bpmn-io/cm-theme/issues/4 */\n.bio-properties-panel-feelers-editor .cm-content ::selection {\n  background: var(--feelers-select-color, hsl(205, 100%, 85%));\n}\n\n.bio-properties-panel-feelers-editor .cm-editor.cm-focused {\n  background-color: transparent;\n}\n\n.bio-properties-panel-feel-editor-container .bio-properties-panel-input {\n  resize: none;\n  overflow: hidden;\n  overflow-y: auto;\n}\n\n.bio-properties-panel-feel-editor-container,\n.bio-properties-panel-feel-editor-container .bio-properties-panel-input,\n.bio-properties-panel-feel-container .cm-editor {\n  min-height: 100%;\n}\n\n.bio-properties-panel-feel-checkbox,\n.bio-properties-panel-feel-toggle-switch {\n  padding-top: 1px;\n}\n\n.bio-properties-panel-feel-checkbox .bio-properties-panel-feel-entry:not(.feel-active),\n.bio-properties-panel-feel-toggle-switch .bio-properties-panel-feel-entry:not(.feel-active) {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.bio-properties-panel-feel-checkbox .bio-properties-panel-feel-entry:not(.feel-active) .bio-properties-panel-feel-container,\n.bio-properties-panel-feel-toggle-switch .bio-properties-panel-feel-entry:not(.feel-active) .bio-properties-panel-feel-container {\n  margin-left: auto;\n}\n\n.bio-properties-panel-tooltip-wrapper {\n  text-decoration: underline;\n  text-decoration-style: dotted;\n  text-underline-offset: 2px;\n  font: inherit;\n  display: flex;\n  justify-content: center;\n  width: fit-content;\n}\n\n.bio-properties-panel-tooltip {\n  --tooltip-underline-color: var(--color-blue-219-99-53);\n  --tooltip-background-color: var(--color-grey-0-0-22);\n  --tooltip-link: var(--color-blue-218-100-74);\n  --tooltip-code-background-color: var(--color-grey-225-10-97);\n  --tooltip-code-border-color: var(--color-grey-225-10-85);\n  display: flex;\n  color: var(--color-white, white);\n  position: fixed;\n  z-index: 1000;\n  max-width: 300px;\n  font-size: var(--text-size-small);\n  font-family: var(--font-family);\n}\n\n.bio-properties-panel-tooltip.right {\n  padding-right: 6px;\n}\n\n.bio-properties-panel-tooltip.top {\n  flex-direction: column;\n}\n\n.bio-properties-panel-tooltip-content {\n  background-color: var(--tooltip-background-color);\n  padding: 16px;\n  border-radius: 2px;\n  font-weight: 400;\n  white-space: pre-wrap;\n}\n\n.bio-properties-panel-tooltip-content h1 {\n  font-size: var(--text-size-base);\n  font-weight: bold;\n  margin: 0;\n}\n\n.bio-properties-panel-tooltip-content code,\n.bio-properties-panel-tooltip-content pre {\n  color: var(--description-color);\n  font-family: var(--font-family);\n  font-size: var(--text-size-small);\n  line-height: var(--line-height-condensed);\n  padding: 0 2px;\n  background-color: var(--tooltip-code-background-color);\n  border: 1px solid var(--tooltip-code-border-color);\n  border-radius: 3px;\n}\n\n.bio-properties-panel-tooltip-content pre code {\n  border: none;\n}\n\n.bio-properties-panel-tooltip p:first-child {\n  margin-top: 0;\n}\n\n.bio-properties-panel-tooltip p:last-child {\n  margin-bottom: 0;\n}\n\n.bio-properties-panel-tooltip-content a {\n  color: var(--tooltip-link);\n}\n\n.bio-properties-panel-tooltip .bio-properties-panel-tooltip-arrow {\n  width: 0;\n  height: 0;\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 5px solid var(--tooltip-background-color);\n  margin-top: 16px;\n}\n\n.bio-properties-panel-tooltip.top .bio-properties-panel-tooltip-arrow {\n  margin-top: -3px;\n  margin-left: calc(50% - 2.5px);\n  transform: rotate(90deg);\n}\n\n.bio-properties-panel-feelers-editor-container .bio-properties-panel-feelers-editor__open-popup-placeholder,\n.bio-properties-panel-feel-editor-container .bio-properties-panel-feel-editor__open-popup-placeholder {\n  display: none;\n  justify-content: center;\n  flex-direction: column;\n  color: hsla(0, 0%, 9%, 0.25);\n  padding: 3px 6px 2px;\n  border: 1px solid var(--input-border-color);\n  border-radius: 2px;\n  background-color: var(--input-background-color);\n  font-size: var(--text-size-base);\n  font-family: inherit;\n  width: 100%;\n  min-height: 100%;\n}\n\n.bio-properties-panel-feelers-editor-container.popupOpen .bio-properties-panel-input,\n.bio-properties-panel-feel-editor-container.popupOpen .bio-properties-panel-input {\n  display: none;\n}\n\n.bio-properties-panel-feelers-editor-container.popupOpen .bio-properties-panel-feelers-editor__open-popup-placeholder,\n.bio-properties-panel-feel-editor-container.popupOpen .bio-properties-panel-feel-editor__open-popup-placeholder {\n  display: flex;\n}\n\n.bio-properties-panel-popup {\n  --popup-background-color: hsla(0, 0%, 96%, 1);\n  --popup-header-background-color: white;\n  --popup-font-color: hsla(0, 0%, 0%, 1);\n  --popup-title-color: hsla(0, 0%, 0%, 1);\n  --feel-popup-close-background-color: hsla(219, 99%, 53%, 1);\n  --feel-popup-gutters-background-color: hsla(0, 0%, 90%, 1);\n  position: fixed;\n  display: flex;\n  flex: auto;\n  flex-direction: column;\n  font-family: IBM Plex Sans, sans-serif;\n  padding: 0;\n  z-index: 1001;\n  box-shadow: 0px 2px 6px 0px hsla(0, 0%, 0%, 0.3);\n  background-color: var(--popup-background-color);\n  color: var(--popup-font-color);\n  height: auto;\n  width: auto;\n  overflow: hidden;\n  font-size: 14px;\n}\n\n.bio-properties-panel-popup h1,\n.bio-properties-panel-popup h2,\n.bio-properties-panel-popup h3,\n.bio-properties-panel-popup h4 {\n  font-weight: 500;\n  font-size: inherit;\n}\n\n.bio-properties-panel-popup .bio-properties-panel-popup__header,\n.bio-properties-panel-popup .bio-properties-panel-popup__body,\n.bio-properties-panel-popup .bio-properties-panel-popup__footer {\n  padding: 12px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.bio-properties-panel-popup .bio-properties-panel-popup__body:not(:first-child) {\n  padding-top: 0;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.bio-properties-panel-popup .bio-properties-panel-popup__header {\n  --popup-header-line-height: 16px;\n  background-color: var(--popup-header-background-color);\n  margin: 0;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: var(--popup-header-line-height);\n  text-align: left;\n  color: var(--popup-title-color);\n}\n\n.bio-properties-panel-popup .bio-properties-panel-popup__header.draggable {\n  cursor: grab;\n}\n\n.bio-properties-panel-popup .bio-properties-panel-popup__drag-handle {\n  display: flex;\n}\n\n.bio-properties-panel-popup .bio-properties-panel-popup__drag-preview {\n  width: 1px;\n  height: 1px;\n  position: absolute;\n  top: 0;\n}\n\n.bio-properties-panel-popup .bio-properties-panel-popup__title {\n  margin-left: 8px;\n}\n\n.bio-properties-panel-popup .bio-properties-panel-popup__title::first-letter {\n  text-transform: capitalize;\n}\n\n.bio-properties-panel-popup .bio-properties-panel-popup__close {\n  margin: -12px;\n  margin-left: 12px;\n  width: 40px;\n  height: 40px;\n  border: none;\n  background-color: var(--popup-header-background-color);\n}\n\n.bio-properties-panel-popup .bio-properties-panel-popup__close:hover,\n.bio-properties-panel-popup .bio-properties-panel-popup__close:focus-visible {\n  background-color: var(--popup-background-color);\n}\n\n.bio-properties-panel-popup .bio-properties-panel-popup__close:focus-visible {\n  outline-offset: -2px;\n}\n\n.bio-properties-panel-popup .bio-properties-panel-popup__close svg {\n  width: 16px;\n  height: 16px;\n  fill: currentColor;\n  margin-top: 2px;\n}\n\n.bio-properties-panel-popup .bio-properties-panel-popup__header .bio-properties-panel-popup__drag-handle svg {\n  margin-left: -4px;\n}\n\n.bio-properties-panel-popup .bio-properties-panel-popup__body {\n  font-size: inherit;\n  height: 100%;\n  display: flex;\n  overflow: auto;\n  padding-bottom: 0;\n}\n\n.bio-properties-panel-popup .bio-properties-panel-popup__footer {\n  position: absolute;\n  bottom: 0;\n  right: 8px;\n}\n\n.bio-properties-panel-feel-popup {\n  min-height: 400px;\n  width: fit-content;\n}\n\n.bio-properties-panel-feel-popup .bio-properties-panel-feel-popup__body {\n  display: flex;\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  width: 100%;\n}\n\n.bio-properties-panel-feel-popup__title-link {\n  margin-left: 8px;\n  display: flex;\n}\n\n.bio-properties-panel-feel-popup__title-link:first-of-type {\n  margin-left: auto;\n}\n\n.bio-properties-panel-feel-popup__title-link svg {\n  width: var(--popup-header-line-height);\n  height: var(--popup-header-line-height);\n  fill: currentColor;\n  margin: 0 0.5em;\n}\n\n.bio-properties-panel-feel-popup .bio-properties-panel-feel-editor-container {\n  display: flex;\n  min-width: 100%;\n}\n\n.bio-properties-panel-feel-popup .bio-properties-panel-feel-editor-container .cm-scroller {\n  overflow: auto !important;\n}\n\n.bio-properties-panel-feel-popup .bio-properties-panel-feelers-editor-container {\n  width: 100%;\n  display: flex;\n}\n\n.bio-properties-panel-feel-popup .bio-properties-panel-feelers-editor-container .bio-properties-panel-feelers-editor {\n  display: flex;\n}\n\n.bio-properties-panel-feel-popup .bio-properties-panel-feelers-editor-container .bio-properties-panel-feelers-editor .cm-editor {\n  width: 100%;\n}\n\n.bio-properties-panel-feel-popup .bio-properties-panel-input {\n  width: 100%;\n  resize: none;\n  padding: 0;\n  overflow: hidden;\n  overflow-y: auto;\n}\n\n.bio-properties-panel-feel-popup .bio-properties-panel-open-feel-popup {\n  display: none !important;\n}\n\n.bio-properties-panel-feelers-editor-container .bio-properties-panel-open-feel-popup,\n.bio-properties-panel-feel-container .bio-properties-panel-open-feel-popup {\n  position: absolute;\n  top: 0;\n  right: 0;\n  line-height: 1;\n  padding: 2px 4px;\n  margin: 3px;\n  display: none;\n  background: none;\n  border: none;\n  color: var(--feel-open-popup-color);\n  cursor: pointer;\n}\n\n.bio-properties-panel-feelers-editor-container:hover .bio-properties-panel-open-feel-popup,\n.bio-properties-panel-feel-container:hover .bio-properties-panel-open-feel-popup,\n.bio-properties-panel-feelers-editor-container:focus-within .bio-properties-panel-open-feel-popup,\n.bio-properties-panel-feel-container:focus-within .bio-properties-panel-open-feel-popup {\n  display: block;\n}\n\n.bio-properties-panel-feelers-editor-container .bio-properties-panel-open-feel-popup:hover,\n.bio-properties-panel-feel-container .bio-properties-panel-open-feel-popup:hover {\n  color: var(--feel-open-popup-hover-color);\n}\n\n.bio-properties-panel-feel-popup .bio-properties-panel-popup__footer .bio-properties-panel-feel-popup__close-btn {\n  background: var(--feel-popup-close-background-color);\n  width: 66px;\n  font-weight: 400;\n  font-size: 14px;\n  font-family: inherit;\n  color: white;\n  border: none;\n  height: 32px;\n  cursor: pointer;\n}\n\n.bio-properties-panel-feel-popup .bio-properties-panel-feel-editor-container .cm-editor {\n  width: 100%;\n  height: 100%;\n}\n\n.bio-properties-panel-feel-popup .bio-properties-panel-feel-editor-container .cm-editor .cm-content {\n  padding-left: 4px;\n}\n\n.bio-properties-panel-feel-popup .bio-properties-panel-input {\n  border: none;\n}\n\n.bio-properties-panel-feel-popup .cm-gutters {\n  background-color: var(--feel-popup-gutters-background-color);\n  border: none;\n  padding: 0;\n}\n\n.bio-properties-panel-feel-popup .cm-gutter {\n  min-width: 32px;\n}\n\n.bio-properties-panel-feel-popup .cm-gutters .cm-lineNumbers .cm-gutterElement {\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
